export enum TK {
    appointmint = 'appointmint',
    welcome = 'welcome',
    profile = 'profile',
    professionalDetails = 'professionalDetails',
    accountSecurity = 'accountSecurity',
    visibleToClients = 'visibleToClients',
    loginAndSecurity = 'loginAndSecurity',
    fullName = 'fullName',
    accountType = 'accountType',
    usernameLogin = 'usernameLogin',
    usernameLoginPrimaryHint = 'usernameLoginPrimaryHint',
    usernameLoginSecondaryHint = 'usernameLoginSecondaryHint',
    usernameOrEmail = 'usernameOrEmail',
    userEmailLoginHelp = 'userEmailLoginHelp',
    signInMethods = 'signInMethods',
    signInMethodsDescription = 'signInMethodsDescription',
    signInMethodsAvailable = 'signInMethodsAvailable',
    sendNewPasswordByEmail = 'sendNewPasswordByEmail',
    passwordManagement = 'passwordManagement',
    newPassword = 'newPassword',
    confirmPassword = 'confirmPassword',
    saveChanges = 'saveChanges',
    changesSaved = 'changesSaved',
    editProfilePhoto = 'editProfilePhoto',
    view = 'view',
    manage = 'manage',
    manager = 'manager',
    managerHelpText = 'managerHelpText',
    managing = 'managing',
    userBranches = 'userBranches',
    userBranchesHelp = 'userBranchesHelp',
    noBranchGroup = 'noBranchGroup',
    taskBranchRequired = 'taskBranchRequired',
    showOrgChart = 'showOrgChart',
    orgChart = 'orgChart',
    chat = 'chat',
    myClients = 'myClients',
    login = 'login',
    logout = 'logout',
    password = 'password',
    submit = 'submit',
    username = 'username',
    myprofile = 'myprofile',
    settings = 'settings',
    accountAndSubscription = 'accountAndSubscription',
    users = 'users',
    user = 'user',
    responsible = 'responsible',
    id = 'id',
    wrongUsernameOrPassword = 'wrongUsernameOrPassword',
    somethingWrongWithYourLogin = 'somethingWrongWithYourLogin',
    administrator = 'administrator',
    canSeePrices = 'canSeePrices',
    canManagePrices = 'canManagePrices',
    canManageProfessionals = 'canManageProfessionals',
    seeClients = 'seeClients',
    seeClientsReports = 'seeClientsReports',
    canManageClients = 'canManageClients',
    seeAppointments = 'seeAppointments',
    canManageAppointments = 'canManageAppointments',
    canManageCampaigns = 'canManageCampaigns',
    canManageSms = 'canManageSms',
    clients = 'clients',
    client = 'client',
    areYouSure = 'areYouSure',
    youRAboutToDelete = 'youRAboutToDelete',
    migrateDataToClient = 'migrateDataToClient',
    migrateDataToClientDescription = 'migrateDataToClientDescription',
    youRAboutToSave = 'youRAboutToSave',
    confirmPasswordChange = 'confirmPasswordChange',
    youRAboutToChangePassword = 'youRAboutToChangePassword',
    delete = 'delete',
    cancel = 'cancel',
    save = 'save',
    changePassword = 'changePassword',
    passwordsMustMatch = 'passwordsMustMatch',
    permissions = 'permissions',
    enter = 'enter',
    open = 'open',
    create = 'create',
    loggedIn = 'loggedIn',
    loggedOut = 'loggedOut',
    savedSuccessfully = 'savedSuccessfully',
    somethingWentWrong = 'somethingWentWrong',
    entityDeletedSuccessfully = 'entityDeletedSuccessfully',
    entityChangedSuccessfully = 'entityChangedSuccessfully',
    entityCreatedSuccessfully = 'entityCreatedSuccessfully',
    professionals = 'professionals',
    professional = 'professional',
    visibleForAllProfessionals = 'visibleForAllProfessionals',
    hasPortalAccess = 'hasPortalAccess',
    associateUserWithProfessional = 'associateUserWithProfessional',
    name = 'name',
    biography = 'biography',
    biographyPlaceholder = 'biographyPlaceholder',
    registrationNumber = 'registrationNumber',
    identificationNumber = 'identificationNumber',
    email = 'email',
    profilePictureUrl = 'profilePictureUrl',
    profilePictureUpdated = 'profilePictureUpdated',
    profilePictureRemoved = 'profilePictureRemoved',
    errorUploadingProfilePicture = 'errorUploadingProfilePicture',
    onlyImageFilesAllowed = 'onlyImageFilesAllowed',
    fileSizeMustBeLessThan5MB = 'fileSizeMustBeLessThan5MB',
    fileSizeMustBeLessThan2MB = 'fileSizeMustBeLessThan2MB',
    sms = 'sms',
    phoneCall = 'phoneCall',
    smsExhausted = 'smsExhausted',
    clientPhoneRequiredForSmsCommunication = 'clientPhoneRequiredForSmsCommunication',
    taxNumber = 'taxNumber',
    origin = 'origin',
    subsystemName = 'subsystemName',
    subsystemNumber = 'subsystemNumber',
    phoneNumbers = 'phoneNumbers',
    phoneNumber = 'phoneNumber',
    address = 'address',
    warning = 'warning',
    quotaReachedOn = 'quotaReachedOn',
    youHaveNoEmailsLeft = 'youHaveNoEmailsLeft',
    youOnlyHaveOneEmailLeft = 'youOnlyHaveOneEmailLeft',
    youOnlyHaveEmailsLeft = 'youOnlyHaveEmailsLeft',
    youHaveNoSmsLeft = 'youHaveNoSmsLeft',
    youOnlyHaveOneSmsLeft = 'youOnlyHaveOneSmsLeft',
    youOnlyHaveSmsLeft = 'youOnlyHaveSmsLeft',
    youHaveNoWhatsAppsLeft = 'youHaveNoWhatsAppsLeft',
    youOnlyHaveOneWhatsAppLeft = 'youOnlyHaveOneWhatsAppLeft',
    youOnlyHaveWhatsAppsLeft = 'youOnlyHaveWhatsAppsLeft',
    notes = 'notes',
    sex = 'sex',
    unspecified = 'unspecified',
    male = 'male',
    female = 'female',
    availability = 'availability',
    dayMonday = 'dayMonday',
    dayTuesday = 'dayTuesday',
    dayWednesday = 'dayWednesday',
    dayThursday = 'dayThursday',
    dayFriday = 'dayFriday',
    daySaturday = 'daySaturday',
    daySunday = 'daySunday',
    dayHoliday = 'dayHoliday',
    birthdate = 'birthdate',
    birthdayYear = 'birthdayYear',
    birthdayMonth = 'birthdayMonth',
    birthdayDay = 'birthdayDay',
    services = 'services',
    addNewToSet = 'addNewToSet',
    notFoundInSet = 'notFoundInSet',
    pressEnterToSearch = 'pressEnterToSearch',
    general = 'general',
    subSystems = 'subSystems',
    origins = 'origins',
    color = 'color',
    calendar = 'calendar',
    room = 'room',
    day = 'day',
    start = 'start',
    end = 'end',
    price = 'price',
    type = 'type',
    rooms = 'rooms',
    time = 'time',
    dateTime = 'dateTime',
    dueDate = 'dueDate',
    happened = 'happened',
    yes = 'yes',
    no = 'no',
    payment = 'payment',
    payments = 'payments',
    healthNumber = 'healthNumber',
    job = 'job',
    zipCode = 'zipCode',
    city = 'city',
    showMore = 'showMore',
    defaultPrices = 'defaultPrices',
    defaultPrice = 'defaultPrice',
    category = 'category',
    language = 'language',
    version = 'version',
    discard = 'discard',
    settingsUpdated = 'settingsUpdated',
    workingHours = 'workingHours',
    data = 'data',
    appointments = 'appointments',
    addAppointments = 'addAppointments',
    selectAppointments = 'selectAppointments',
    noAppointmentsFound = 'noAppointmentsFound',
    assignToEntity = 'assignToEntity',
    assignInvoice = 'assignInvoice',
    assignInvoiceTitle = 'assignInvoiceTitle',
    selectEntityType = 'selectEntityType',
    selectEntities = 'selectEntities',
    noEntitiesFound = 'noEntitiesFound',
    invoiceAssignedSuccessfully = 'invoiceAssignedSuccessfully',
    appointment = 'appointment',
    creatingAppointment = 'creatingAppointment',
    deletingAppointment = 'deletingAppointment',
    loadMore = 'loadMore',
    edit = 'edit',
    privacyPolicy = 'privacyPolicy',
    privacyPolicyContent = 'privacyPolicyContent',
    whatsappTemplateRequiredDisclaimer = 'whatsappTemplateRequiredDisclaimer',
    freeTextSwitchMessage = 'freeTextSwitchMessage',
    emailNotConfirmedMessage = 'emailNotConfirmedMessage',
    emailSentSuccessfully = 'emailSentSuccessfully',
    resendConfirmationEmail = 'resendConfirmationEmail',
    confirmationEmailSent = 'confirmationEmailSent',
    haveYouForgottenYourPassword = 'haveYouForgottenYourPassword',
    resetPassword = 'resetPassword',
    emailConfirmed = 'emailConfirmed',
    newPasswordSent = 'newPasswordSent',
    newPasswordWillBeSent = 'newPasswordWillBeSent',
    resetPasswordEmailSent = 'resetPasswordEmailSent',
    cantSendResetPasswordEmail = 'cantSendResetPasswordEmail',
    newPasswordEmailSentIfPasswordIsEmpty = 'newPasswordEmailSentIfPasswordIsEmpty',
    fromEmail = 'fromEmail',
    fromName = 'fromName',
    changedByAt = 'changedByAt',
    createdByAt = 'createdByAt',
    created = 'created',
    changed = 'changed',
    unknown = 'unknown',
    changeLog = 'changeLog',
    date = 'date',
    paymentDate = 'paymentDate',
    action = 'action',
    sunday = 'sunday',
    monday = 'monday',
    tuesday = 'tuesday',
    wendesday = 'wendesday',
    thursday = 'thursday',
    friday = 'friday',
    saturday = 'saturday',
    week = 'week',
    month = 'month',
    readIdentifyCard = 'readIdentifyCard',
    height = 'height',
    confirmed = 'confirmed',
    confirm = 'confirm',
    confirmation = 'confirmation',
    invoiceProviderChangeWarning = 'invoiceProviderChangeWarning',
    invoiceClientChangeWarning = 'invoiceClientChangeWarning',
    notConfirmed = 'notConfirmed',
    paid = 'paid',
    notPaid = 'notPaid',
    billing = 'billing',
    billingInvoices = 'billingInvoices',
    page = 'page',
    previous = 'previous',
    next = 'next',
    all = 'all',
    byDay = 'byDay',
    byWeek = 'byWeek',
    byMonth = 'byMonth',
    byDate = 'byDate',
    byProfessional = 'byProfessional',
    byChannel = 'byChannel',
    byAppointmentType = 'byAppointmentType',
    selectEntireMonth = 'selectEntireMonth',
    selectToday = 'selectToday',
    today = 'today',
    total = 'total',
    totalPaid = 'totalPaid',
    missingToPay = 'missingToPay',
    missingPayment = 'missingPayment',
    totals = 'totals',
    totalToBePaid = 'totalToBePaid',
    items = 'items',
    expenses = 'expenses',
    expense = 'expense',
    stock = 'stock',
    stockItem = 'stockItem',
    buyStock = 'buyStock',
    updateStockQuantity = 'updateStockQuantity',
    createExpense = 'createExpense',
    salary = 'salary',
    billingPercentages = 'billingPercentages',
    billingPercentage = 'billingPercentage',
    effectiveValueProducedByProfessional = 'effectiveValueProducedByProfessional',
    professionalParcel = 'professionalParcel',
    calculation = 'calculation',
    count = 'count',
    close = 'close',
    retry = 'retry',
    back = 'back',
    report = 'report',
    reports = 'reports',
    noReportCreatedYet = 'noReportCreatedYet',
    reportConfiguration = 'reportConfiguration',
    reportGenerationQuotaInfo = 'reportGenerationQuotaInfo',
    reportGenerationPrompt = 'reportGenerationPrompt',
    reportGenerationPromptHelp = 'reportGenerationPromptHelp',
    generateReportTemplate = 'generateReportTemplate',
    regenerateReportTemplate = 'regenerateReportTemplate',
    refineWithAI = 'refineWithAI',
    surveyGenerationQuotaInfo = 'surveyGenerationQuotaInfo',
    surveyGenerationPrompt = 'surveyGenerationPrompt',
    surveyGenerationPromptHelp = 'surveyGenerationPromptHelp',
    generateSurvey = 'generateSurvey',
    regenerateSurvey = 'regenerateSurvey',
    shareSurvey = 'shareSurvey',
    shareSurveyHelp = 'shareSurveyHelp',
    surveyShareLink = 'surveyShareLink',
    copyLink = 'copyLink',
    linkCopied = 'linkCopied',
    sendToContact = 'sendToContact',
    sendToContactHelp = 'sendToContactHelp',
    sendByEmail = 'sendByEmail',
    sendByWhatsApp = 'sendByWhatsApp',
    contactName = 'contactName',
    contactEmail = 'contactEmail',
    contactPhone = 'contactPhone',
    surveyIndividualResponses = 'surveyIndividualResponses',
    surveyResponseAnonymous = 'surveyResponseAnonymous',
    surveyNoIndividualResponses = 'surveyNoIndividualResponses',
    addField = 'addField',
    addQuestion = 'addQuestion',
    new = 'new',
    add = 'add',    
    createReport = 'createReport',
    createManually = 'createManually',
    createWithAI = 'createWithAI',
    newField = 'newField',
    text = 'text',
    multilineText = 'multilineText',
    intNumber = 'intNumber',
    floatNumber = 'floatNumber',
    availableFor = 'availableFor',
    loading = 'loading',
    comingSoon = 'comingSoon',
    calculating = 'calculating',
    description = 'description',
    helpNotes = 'helpNotes',
    multiOptions = 'multiOptions',
    options = 'options',
    thisFieldIsMandatory = 'thisFieldIsMandatory',
    bodyChart = 'bodyChart',
    mobilityChart = 'mobilityChart',
    separator = 'separator',
    title = 'title',
    scale = 'scale',
    reminders = 'reminders',
    message = 'message',
    howMuchTimeBefore = 'howMuchTimeBefore',
    twoHours = 'twoHours',
    fourHours = 'fourHours',
    oneDay = 'oneDay',
    twoDays = 'twoDays',
    threeDays = 'threeDays',
    oneWeek = 'oneWeek',
    emailReminders = 'emailReminders',
    smsReminders = 'smsReminders',
    appointmentConfirmationRequest = 'appointmentConfirmationRequest',
    confirmationAllowedResponses = 'confirmationAllowedResponses',
    confirmationAcceptResponses = 'confirmationAcceptResponses',
    confirmationAcceptResponsesHelp = 'confirmationAcceptResponsesHelp',
    confirmationRejectResponsesHelp = 'confirmationRejectResponsesHelp',
    confirmationRejectResponses = 'confirmationRejectResponses',
    appointmentConfirmationDefaultName = 'appointmentConfirmationDefaultName',
    appointmentConfirmationDefaultMessage = 'appointmentConfirmationDefaultMessage',
    appointmentConfirmationFlowTooltip = 'appointmentConfirmationFlowTooltip',
    clientReminders = 'clientReminders',
    taskManagement = 'taskManagement',
    tasks = 'tasks',
    task = 'task',
    taskTypeReminderClientFollowUp = 'taskTypeReminderClientFollowUp',
    taskTypeReminders = 'taskTypeReminders',
    taskTypeOther = 'taskTypeOther',
    taskStatusPending = 'taskStatusPending',
    taskStatusCompleted = 'taskStatusCompleted',
    taskStatusDismissed = 'taskStatusDismissed',
    completeTask = 'completeTask',
    dismissTask = 'dismissTask',
    assignTask = 'assignTask',
    unassignTask = 'unassignTask',
    createTask = 'createTask',
    activeTasks = 'activeTasks',
    seeAllTasks = 'seeAllTasks',
    taskDetails = 'taskDetails',
    dismissReasonNotApplicable = 'dismissReasonNotApplicable',
    dismissReasonClientCancelled = 'dismissReasonClientCancelled',
    dismissReason = 'dismissReason',
    completedAt = 'completedAt',
    completeAndGoToCommunication = 'completeAndGoToCommunication',
    dueOverdue = 'dueOverdue',
    dueToday = 'dueToday',
    dueTomorrow = 'dueTomorrow',
    noTasksFound = 'noTasksFound',
    clientsFollowUp = 'clientsFollowUp',
    professionalReminders = 'professionalReminders',
    automaticFollowUp = 'automaticFollowUp',
    remindAdminsAfterFirstCustomerAppointment = 'remindAdminsAfterFirstCustomerAppointment',
    taskManagementDescription = 'taskManagementDescription',
    autoCreateClientFollowUpTask = 'autoCreateClientFollowUpTask',
    autoCreateClientFollowUpTaskHelp = 'autoCreateClientFollowUpTaskHelp',
    daysAfterFirstAppointment = 'daysAfterFirstAppointment',
    sendAutomaticFollowUpCommunication = 'sendAutomaticFollowUpCommunication',
    followUpCommunicationChannel = 'followUpCommunicationChannel',
    followUpCommunicationSubjectTemplate = 'followUpCommunicationSubjectTemplate',
    followUpCommunicationTemplate = 'followUpCommunicationTemplate',
    followUpWhatsAppSessionWarning = 'followUpWhatsAppSessionWarning',
    clientsFollowUpCommunicationDefaultTemplate = 'clientsFollowUpCommunicationDefaultTemplate',
    communicationChannels = 'communicationChannels',
    selectChannelsToConfigureReminders = 'selectChannelsToConfigureReminders',
    selectChannelsForConfirmation = 'selectChannelsForConfirmation',
    sendToAllServicesTypes = 'sendToAllServicesTypes',
    remindersServiceTypesHelpNote = 'remindersServiceTypesHelpNote',
    remindersNoServiceTypesSelectedWarning = 'remindersNoServiceTypesSelectedWarning',
    remindersWhatsAppSmsFallbackDisclaimer = 'remindersWhatsAppSmsFallbackDisclaimer',
    confirmationWhatsAppSmsFallbackDisclaimer = 'confirmationWhatsAppSmsFallbackDisclaimer',
    whatsAppTemplateMetaWarning = 'whatsAppTemplateMetaWarning',
    whatsAppReminderDefaultTemplate = 'whatsAppReminderDefaultTemplate',
    whatsAppConfirmationDefaultTemplate = 'whatsAppConfirmationDefaultTemplate',
    smsDefaultText = 'smsDefaultText',
    emailDefaultSubject = 'emailDefaultSubject',
    emailDefaultText = 'emailDefaultText',
    whatsAppMetaReviewDisclaimerStart = 'whatsAppMetaReviewDisclaimerStart',
    whatsAppMetaReviewDisclaimerEnd = 'whatsAppMetaReviewDisclaimerEnd',
    emailSettings = 'emailSettings',
    reminderMessage = 'reminderMessage',
    whenToSend = 'whenToSend',
    whenToSendNote = 'whenToSendNote',
    confirmationMessage = 'confirmationMessage',
    reminderDifferentMessagesWarning = 'reminderDifferentMessagesWarning',
    clientConfirmedAppointment = 'clientConfirmedAppointment',
    clientRejectedAppointment = 'clientRejectedAppointment',
    clientAwaitingConfirmation = 'clientAwaitingConfirmation',
    confirmationResponseYes = 'confirmationResponseYes',
    confirmationResponseNo = 'confirmationResponseNo',
    confirmationResponseCancel = 'confirmationResponseCancel',
    subject = 'subject',
    preheader = 'preheader',
    goal = 'goal',
    internalDescription = 'internalDescription',
    senderName = 'senderName',
    senderEmail = 'senderEmail',
    ignoreAvailability = 'ignoreAvailability',
    ignoreAvailabilityRecurringHelp = 'ignoreAvailabilityRecurringHelp',
    disableAutoCancellation = 'disableAutoCancellation',
    print = 'print',
    copy = 'copy',
    companyName = 'companyName',
    companyImage = 'companyImage',
    companyLegalInfo = 'companyLegalInfo',
    contactInformation = 'contactInformation',
    descriptive = 'descriptive',
    contact = 'contact',
    postalCode = 'postalCode',
    imageSizeMustBeLessThanKB = 'imageSizeMustBeLessThanKB',
    remove = 'remove',
    imageMarket = 'imageMarker',
    image = 'image',
    markers = 'markers',
    clearMarkers = 'clearMarkers',
    pack = 'pack',
    packs = 'packs',
    packConfiguration = 'packConfiguration',
    packUnavailableForAppointmentType = 'packUnavailableForAppointmentType',
    availableInPacks = 'availableInPacks',
    totalMinutes = 'totalMinutes',
    addPack = 'addPack',
    noPackAddedYet = 'noPackAddedYet',
    orders = 'orders',
    addOrder = 'addOrder',
    noOrderAddedYet = 'noOrderAddedYet',
    orderItems = 'orderItems',
    orderTotal = 'orderTotal',
    noStockItemsYet = 'noStockItemsYet',
    duration = 'duration',
    available = 'available',
    notInUseYet = 'notInUseYet', 
    yearsOld = 'yearsOld',
    search = 'search',
    fromEmailWarningMessage = 'fromEmailWarningMessage',
    reminderSmsWarningMessage = 'reminderSmsWarningMessage',
    uploadFile = 'uploadFile',
    file ='file',
    table = 'table',
    defaultValue = 'defaultValue',
    columns = 'columns',
    reportTableDefinitionNote = 'reportTableDefinitionNote',
    empty = 'empty',
    mandatoryFor = 'mandatoryFor',
    availableForAdministratives = 'availableForAdministratives',
    reportsAndDocuments = 'reportsAndDocuments',
    hideLabel = 'hideLabel',
    readOnly = 'readOnly',
    centered = 'centered',
    block = 'block',
    fontSize = 'fontSize',
    hideHeader = 'hideHeader',
    reportDefaultValueNote = 'reportDefaultValueNote',
    testSms = 'testSms',
    testEmail = 'testEmail',
    testWhatsApp = 'testWhatsApp',
    send = 'send',
    sent = 'sent',
    pending = 'pending',
    invalidEmail = 'invalidEmail',
    invalidPhoneNumber = 'invalidPhoneNumber',
    testReminder = 'testReminder',
    admin = 'admin',
    plafontExausted = 'plafontExausted',
    totalAppointmentsThisMonth = 'totalAppointmentsThisMonth',
    totalAppointmentsLastMonth = 'totalAppointmentsLastMonth',
    totalSmsThisMonth = 'totalSmsThisMonth',
    totalSmsLastMonth = 'totalSmsLastMonth',
    totalEmailsThisMonth = 'totalEmailsThisMonth',
    totalEmailsLastMonth = 'totalEmailsLastMonth',
    documentsStorage = 'documentsStorage',
    databaseStorage = 'databaseStorage',
    totalUsers = 'totalUsers',
    totalProfessionals = 'totalProfessionals',
    totalClients = 'totalClients',
    notAllowedToPerformThisOperation = 'notAllowedToPerformThisOperation',
    filter = 'filter',
    from = 'from',
    to = 'to',
    content = 'content',
    channel = 'channel',
    communications = 'communications',
    stats = 'stats',
    smsSegmentsWarning = 'smsSegmentsWarning',
    smsNumberOfSegments = 'smsNumberOfSegments',
    summary = 'summary',
    seeDaySummary = 'seeDaySummary',
    daySummary = 'daySummary',
    totalsAndPaymentsForTheDay = 'totalsAndPaymentsForTheDay',
    entity = 'entity',
    deleted = 'deleted',
    status = 'status',
    requestPayment = 'requestPayment',
    registerPayment = 'registerPayment',
    mbwayWarningMessage = 'mbwayWarningMessage',
    settingsGeneral = 'settingsGeneral',
    settingsPrices = 'settingsPrices',
    settingsExpenses = 'settingsExpenses',
    settingsExtras = 'settingsExtras',
    settingsEmail = 'settingsEmail',
    settingsReports = 'settingsReports',
    settingsPacks = 'settingsPacks',
    settingsReminders = 'settingsReminders',
    settingsSet = 'settingsSet',
    missing = 'missing',
    paidWithPack = 'paidWithPack',
    appointmentsBillingDescription = 'appointmentsBillingDescription',
    paymentsBillingDescription = 'paymentsBillingDescription',
    paymentType = 'paymentType',
    paymentTypes = 'paymentTypes',
    debtors = 'debtors',
    value = 'value',
    percentage = 'percentage',
    perHour = 'perHour',
    fixedValue = 'fixedValue',
    paymentProfile = 'paymentProfile', 
    paymentProfiles = 'paymentProfiles',
    paymentProfileConfiguration = 'paymentProfileConfiguration',
    nrAppointments = 'nrAppointments',
    nrHours = 'nrHours',
    servicesHelpNote = 'servicesHelpNote',
    roomsHelpNote = 'roomsHelpNote',
    paymentTypesHelpNote = 'paymentTypesHelpNote',
    originsHelpNote = 'originsHelpNote',
    subSystemsHelpNote = 'subSystemsHelpNote',
    extras = 'extras',
    extrasAndProducts = 'extrasAndProducts',
    extraConfiguration = 'extraConfiguration',
    extraAvailableForNote = 'extraAvailableForNote',
    extraOnlyForSpecificServices = 'extraOnlyForSpecificServices',
    extraRemoveFromStock = 'extraRemoveFromStock',
    serviceConfiguration = 'serviceConfiguration',
    addNewService = 'addNewService',
    serviceName = 'serviceName',
    expenseForCompany = 'expenseForCompany',
    priceForClient = 'priceForClient',
    professionalProfit = 'professionalProfit',
    byTime = 'byTime',
    byCredits = 'byCredits',
    packByTimeDescription = 'packByTimeDescription',
    packByCreditsDescription = 'packByCreditsDescription',
    totalCredits = 'totalCredits',
    creditsPer = 'creditsPer',
    validityMonths = 'validityMonths',
    credits = 'credits',
    packExhausted = 'packExhausted',
    noteAboutRealPriceWithPack = 'noteAboutRealPriceWithPack',
    thisMonth = 'thisMonth',
    lastMonth = 'lastMonth',
    absoluteValues = 'absoluteValues',
    bySteps = 'bySteps',
    absoluteValuesPaymentProfileDesc = 'absoluteValuesPaymentProfileDesc',
    stepsPaymentProfileDesc = 'stepsPaymentProfileDesc',
    by = 'by',
    absence = 'absence',
    absences = 'absences',
    badRequestPleaseConfirmDataSent = 'badRequestPleaseConfirmDataSent',
    downloadCompanionApp = 'downloadCompanionApp',
    companionConnectionIssueTitle = 'companionConnectionIssueTitle',
    unableToReadIdentityCardMessage = 'unableToReadIdentityCardMessage',
    companionConnectionIssueMessage = 'companionConnectionIssueMessage',
    companionChromeTroubleshootingTitle = 'companionChromeTroubleshootingTitle',
    companionChromeTroubleshootingStep1 = 'companionChromeTroubleshootingStep1',
    companionChromeTroubleshootingStep2 = 'companionChromeTroubleshootingStep2',
    companionChromeTroubleshootingStep3 = 'companionChromeTroubleshootingStep3',
    companionChromeTroubleshootingStep4 = 'companionChromeTroubleshootingStep4',
    companionTryEdgeMessage = 'companionTryEdgeMessage',
    companionRequirementsMessage = 'companionRequirementsMessage',
    downloadAutenticacaoGov = 'downloadAutenticacaoGov',
    downloadAppointmintCompanion = 'downloadAppointmintCompanion',
    downloadCompanionAppMessage = 'downloadCompanionAppMessage',
    download = 'download',
    youReNotAllowedToCreateThisReport = 'youReNotAllowedToCreateThisReport',
    particular = 'particular',
    clientEmailNote = 'clientEmailNote',
    resetClientPassword = 'resetClientPassword',
    sendClientPortalInvite = 'sendClientPortalInvite',
    sendClientPortalNewPassword = 'sendClientPortalNewPassword',
    sendConsentApproval = 'sendConsentApproval',
    consentApprovalEmailSent = 'consentApprovalEmailSent',
    consentApproved = 'consentApproved',
    consentPending = 'consentPending',
    consentEmailSent = 'consentEmailSent',
    consentActiveSingular = 'consentActiveSingular',
    consentActivePlural = 'consentActivePlural',
    consentsNotYetSubmitted = 'consentsNotYetSubmitted',
    clientEmailRequiredForConsentApproval = 'clientEmailRequiredForConsentApproval',
    approveConsents = 'approveConsents',
    consentApprovalSuccess = 'consentApprovalSuccess',
    consentLinkExpired = 'consentLinkExpired',
    consentApprovalExpires30Min = 'consentApprovalExpires30Min',
    consentApprovedOn = 'consentApprovedOn',
    approvedConsents = 'approvedConsents',
    consentApprovalTitle = 'consentApprovalTitle',
    consentApprovalSubtitle = 'consentApprovalSubtitle',
    consentMandatoryConsentsRequired = 'consentMandatoryConsentsRequired',
    consentApprovalRegistered = 'consentApprovalRegistered',
    consentApprovalCloseWindow = 'consentApprovalCloseWindow',
    consentDataUnavailable = 'consentDataUnavailable',
    termsAndConditions = 'termsAndConditions',
    yourNextAppointments = 'yourNextAppointments',
    previousAppointments = 'previousAppointments',
    noClientAppointmentsNote = 'noClientAppointmentsNote',
    company = 'company',
    contacts = 'contacts',
    emailNotConfirmed = 'emailNotConfirmed',
    newPasswordNotGenerated = 'newPasswordNotGenerated',
    goBack = 'goBack',
    photo = 'photo',
    clientsLogin = 'clientsLogin',
    allowClientsLogin = 'allowClientsLogin',
    allowClientsSelfScheduling = 'allowClientsSelfScheduling',
    allowAnonymousSelfScheduling = 'allowAnonymousSelfScheduling',
    allowShareDocumentsWithClients = 'allowShareDocumentsWithClients',
    allowShareDocumentsWithClientsTooltip = 'allowShareDocumentsWithClientsTooltip',
    allowAllRoomsServicesAndProfessionalsByDefault = 'allowAllRoomsServicesAndProfessionalsByDefault',
    appointmentTypesAvailable = 'appointmentTypesAvailable',
    professionalsAvailable = 'professionalsAvailable',
    schedule = 'schedule',
    submittedSuccessfully = 'submittedSuccessfully',
    createdByTheClient = 'createdByTheClient',
    cancelRequestedByTheClient = 'cancelRequestedByTheClient',
    rescheduleRequestedByTheClient = 'rescheduleRequestedByTheClient',
    noAvailability = 'noAvailability',
    clientCancelNote = 'clientCancelNote',
    cancelAppointment = 'cancelAppointment',
    appointmentType = 'appointmentType',
    createAppointment = 'createAppointment',
    createAppointmentAndSendSMS = 'createAppointmentAndSendSMS',
    createOrder = 'createOrder',
    createPack = 'createPack',
    holiday = 'holiday',
    acceptMarketingCommunication = 'acceptMarketingCommunication',
    campaign = 'campaign',
    campaigns = 'campaigns',
    campaignName = 'campaignName',
    campaignSendUsing = 'campaignSendUsing',
    campaignBuilderBasics = 'campaignBuilderBasics',
    campaignBuilderAudience = 'campaignBuilderAudience',
    campaignBuilderContent = 'campaignBuilderContent',
    campaignBuilderReview = 'campaignBuilderReview',
    campaignBuilderSidebar = 'campaignBuilderSidebar',
    campaignBuilderDraftHint = 'campaignBuilderDraftHint',
    campaignBuilderReadyHint = 'campaignBuilderReadyHint',
    campaignBuilderSentHint = 'campaignBuilderSentHint',
    campaignBuilderStep = 'campaignBuilderStep',
    campaignBuilderLastUpdated = 'campaignBuilderLastUpdated',
    campaignBuilderRecipients = 'campaignBuilderRecipients',
    campaignAudienceDisclaimer = 'campaignAudienceDisclaimer',
    campaignAudienceEstimateHint = 'campaignAudienceEstimateHint',
    campaignAudienceEstimateUpdated = 'campaignAudienceEstimateUpdated',
    campaignAudienceEstimatePending = 'campaignAudienceEstimatePending',
    campaignAudienceIncluded = 'campaignAudienceIncluded',
    campaignAudienceExcluded = 'campaignAudienceExcluded',
    campaignExcludedNoMarketingConsent = 'campaignExcludedNoMarketingConsent',
    campaignExcludedConsentNotSubmitted = 'campaignExcludedConsentNotSubmitted',
    campaignExcludedMissingContactInfo = 'campaignExcludedMissingContactInfo',
    campaignExcludedInvalidContactInfo = 'campaignExcludedInvalidContactInfo',
    campaignExcludedDuplicateAddress = 'campaignExcludedDuplicateAddress',
    campaignExcludedManuallyExcluded = 'campaignExcludedManuallyExcluded',
    campaignSampleRecipients = 'campaignSampleRecipients',
    campaignPlaceholderHint = 'campaignPlaceholderHint',
    campaignReviewSummary = 'campaignReviewSummary',
    campaignNotFound = 'campaignNotFound',
    campaignNameRequired = 'campaignNameRequired',
    campaignSubjectRequired = 'campaignSubjectRequired',
    campaignContentRequired = 'campaignContentRequired',
    campaignWhatsAppTemplateRequired = 'campaignWhatsAppTemplateRequired',
    campaignWhatsAppTemplateDisclaimer = 'campaignWhatsAppTemplateDisclaimer',
    campaignSmsBodyRequired = 'campaignSmsBodyRequired',
    campaignSmsBody = 'campaignSmsBody',
    campaignSmsBodyHint = 'campaignSmsBodyHint',
    campaignSmsBodyPlaceholder = 'campaignSmsBodyPlaceholder',
    campaignInvalidSenderEmail = 'campaignInvalidSenderEmail',
    campaignUnknownPlaceholders = 'campaignUnknownPlaceholders',
    campaignInvalidManualEmails = 'campaignInvalidManualEmails',
    campaignNoEligibleRecipients = 'campaignNoEligibleRecipients',
    campaignArchivedCannotSend = 'campaignArchivedCannotSend',
    campaignAlreadySentCannotSend = 'campaignAlreadySentCannotSend',
    campaignViewAnalytics = 'campaignViewAnalytics',
    campaignSendingNote = 'campaignSendingNote',
    campaignSentAnalyticsHint = 'campaignSentAnalyticsHint',
    campaignPreviouslySentHint = 'campaignPreviouslySentHint',
    campaignInvalidTestEmail = 'campaignInvalidTestEmail',
    campaignDiscardChangesConfirm = 'campaignDiscardChangesConfirm',
    campaignIncludeClientsWithoutConsentSubmitted = 'campaignIncludeClientsWithoutConsentSubmitted',
    campaignIgnoreMarketingConsent = 'campaignIgnoreMarketingConsent',
    campaignIncludePhoneNumbers = 'campaignIncludePhoneNumbers',
    campaignGoalCustom = 'campaignGoalCustom',
    campaignGoalReactivateClients = 'campaignGoalReactivateClients',
    campaignGoalPromoteService = 'campaignGoalPromoteService',
    campaignGoalAnnounceNews = 'campaignGoalAnnounceNews',
    campaignGoalBirthdayOrSeasonal = 'campaignGoalBirthdayOrSeasonal',
    campaignPreviewEmpty = 'campaignPreviewEmpty',
    campaignSupportedPlaceholders = 'campaignSupportedPlaceholders',
    campaignPreheaderHint = 'campaignPreheaderHint',
    campaignSenderNameHint = 'campaignSenderNameHint',
    campaignSenderEmailHint = 'campaignSenderEmailHint',
    campaignPreviewPlaceholdersHint = 'campaignPreviewPlaceholdersHint',
    sendNow = 'sendNow',
    createdBy = 'createdBy',
    lastTriggeredBy = 'lastTriggeredBy',
    whatsAppCampaignsComingSoonDescription = 'whatsAppCampaignsComingSoonDescription',
    notifyMeWhenWhatsAppCampaignsReady = 'notifyMeWhenWhatsAppCampaignsReady',
    whatsAppCampaignsNotifyReadySuccess = 'whatsAppCampaignsNotifyReadySuccess',
    newCampaign = 'newCampaign',
    continueDraft = 'continueDraft',
    campaignStatusDraft = 'campaignStatusDraft',
    campaignStatusReady = 'campaignStatusReady',
    campaignStatusAwaitingPayment = 'campaignStatusAwaitingPayment',
    campaignStatusPaid = 'campaignStatusPaid',
    campaignStatusScheduled = 'campaignStatusScheduled',
    campaignStatusSending = 'campaignStatusSending',
    campaignStatusSent = 'campaignStatusSent',
    campaignStatusPartiallyFailed = 'campaignStatusPartiallyFailed',
    campaignStatusFailed = 'campaignStatusFailed',
    campaignStatusArchived = 'campaignStatusArchived',
    campaignNeverSent = 'campaignNeverSent',
    campaignLastTriggered = 'campaignLastTriggered',
    campaignEstimatedRecipients = 'campaignEstimatedRecipients',
    duplicate = 'duplicate',
    duplicateCampaign = 'duplicateCampaign',
    archive = 'archive',
    archiveCampaign = 'archiveCampaign',
    confirmArchiveCampaignBody = 'confirmArchiveCampaignBody',
    campaignsEmptyState = 'campaignsEmptyState',
    campaignsNoResults = 'campaignsNoResults',
    campaignAnalyticsSuccessRate = 'campaignAnalyticsSuccessRate',
    campaignAnalyticsReTriggerEligible = 'campaignAnalyticsReTriggerEligible',
    campaignAnalyticsReTriggerNotEligible = 'campaignAnalyticsReTriggerNotEligible',
    campaignAnalyticsEligibleFrom = 'campaignAnalyticsEligibleFrom',
    campaignAnalyticsFailureBreakdown = 'campaignAnalyticsFailureBreakdown',
    campaignAnalyticsSendHistory = 'campaignAnalyticsSendHistory',
    campaignAnalyticsNoFailures = 'campaignAnalyticsNoFailures',
    campaignAnalyticsBackToBuilder = 'campaignAnalyticsBackToBuilder',
    campaignAnalyticsRead = 'campaignAnalyticsRead',
    campaignAnalyticsSendInProgress = 'campaignAnalyticsSendInProgress',
    campaignAnalyticsReplied = 'campaignAnalyticsReplied',
    campaignAnalyticsSendAgain = 'campaignAnalyticsSendAgain',
    campaignAnalyticsReTriggerReviewTitle = 'campaignAnalyticsReTriggerReviewTitle',
    campaignAnalyticsReTriggerReviewDescription = 'campaignAnalyticsReTriggerReviewDescription',
    campaignAnalyticsCurrentCampaign = 'campaignAnalyticsCurrentCampaign',
    campaignAnalyticsLastSendSnapshot = 'campaignAnalyticsLastSendSnapshot',
    campaignAnalyticsAudienceWillBeRecomputed = 'campaignAnalyticsAudienceWillBeRecomputed',
    campaignAnalyticsConfirmSendAgain = 'campaignAnalyticsConfirmSendAgain',
    campaignAnalyticsOrderRef = 'campaignAnalyticsOrderRef',
    campaignAnalyticsOrderAmount = 'campaignAnalyticsOrderAmount',
    campaignPayRequired = 'campaignPayRequired',
    campaignPayButton = 'campaignPayButton',
    campaignPaySuccess = 'campaignPaySuccess',
    campaignPayCancelled = 'campaignPayCancelled',
    campaignPayError = 'campaignPayError',
    campaignMinPaymentDisclaimer = 'campaignMinPaymentDisclaimer',
    campaignPricingRecipients = 'campaignPricingRecipients',
    campaignEstimatedCost = 'campaignEstimatedCost',
    allStatuses = 'allStatuses',
    allChannels = 'allChannels',
    emailBody = 'emailBody',
    inDebt = 'inDebt',
    inDevelopment = 'inDevelopment',
    professionalsDirectLoginPage = 'professionalsDirectLoginPage',
    copyAccessUrl = 'copyAccessUrl',
    copyPaymentLink = 'copyPaymentLink',
    clientsDirectLoginPage = 'clientsDirectLoginPage',
    anonymousSelfSchedulingPage = 'anonymousSelfSchedulingPage',
    recipients = 'recipients',
    recipientEmails = 'recipientEmails',
    delivered = 'delivered',
    opened = 'opened',
    clicked = 'clicked',
    sendDay = 'sendDay',
    allClients = 'allClients',
    includeClients = 'includeClients',
    excludeClients = 'excludeClients',
    includeEmails = 'includeEmails',
    sentToN = 'sentToN',
    validity = 'validity',
    advanced = 'advanced',
    advancedSearch = 'advancedSearch',
    advancedConfigurations = 'advancedConfigurations',
    viewDebts = 'viewDebts',
    capacity = 'capacity',
    roomCapacityToolTip = 'roomCapacityToolTip',
    roomAvailabilityToolTip = 'roomAvailabilityToolTip',
    active = 'active',
    inactive = 'inactive',
    interval = 'interval',
    exportData = 'exportData',
    exportAttachments = 'exportAttachments',
    doNotUseAppointmentsConfirmation = 'doNotUseAppointmentsConfirmation',
    allowAppointmentsWithoutRoom = 'allowAppointmentsWithoutRoom',
    professionalCanEditAppointmentUpTo = 'professionalCanEditAppointmentUpTo', 
    before = 'before',
    after = 'after',
    hours = 'hours',
    byRoom = 'byRoom',
    detailed = 'detailed',
    cleanupDb = 'cleanupDb',
    cleanupDbWarningMessage = 'cleanupDbWarningMessage',
    yourAccountWillExpireIn = 'yourAccountWillExpireIn',
    days = 'days',
    storageOfYourAccountIsFullWarning = 'storageOfYourAccountIsFullWarning',
    subscriptionExpired = 'subscriptionExpired',
    subscriptionExpiredContactAdmin = 'subscriptionExpiredContactAdmin',
    expiringIn = 'expiringIn',
    withoutPack = 'withoutPack',
    onCreationAndEdition = 'onCreationAndEdition',
    since = 'since',
    actionButtons = 'actionButtons',
    tooltipFields = 'tooltipFields',
    slotGranularity = 'slotGranularity',
    columnWidth = 'columnWidth',
    columnWidthVeryNarrow = 'columnWidthVeryNarrow',
    columnWidthNarrow = 'columnWidthNarrow',
    columnWidthNormal = 'columnWidthNormal',
    columnWidthWide = 'columnWidthWide',
    columnWidthVeryWide = 'columnWidthVeryWide',
    availabilityExtra = 'availabilityExtra',
    internalNotes = 'internalNotes',
    availableForAllServices = 'availableForAllServices',
    validFrom = 'validFrom',
    validUpTo = 'validUpTo',
    acquiredOn = 'acquiredOn',
    validFromTo = 'validFromTo',
    creationDate = 'creationDate',
    integrations = 'integrations',
    invoices = 'invoices',
    invoicesHistory = 'invoicesHistory',
    invoiceSummary = 'invoiceSummary',
    netInvoiced = 'netInvoiced',
    netInvoicedHelp = 'netInvoicedHelp',
    grossInvoiced = 'grossInvoiced',
    grossInvoicedHelp = 'grossInvoicedHelp',
    outstandingAmount = 'outstandingAmount',
    outstandingAmountHelp = 'outstandingAmountHelp',
    totalDocuments = 'totalDocuments',
    totalInvoices = 'totalInvoices',
    totalInvoicesHelp = 'totalInvoicesHelp',
    totalCreditNotes = 'totalCreditNotes',
    totalCreditNotesHelp = 'totalCreditNotesHelp',
    totalReceipts = 'totalReceipts',
    invoiceReceiptHelp = 'invoiceReceiptHelp',
    totalCanceled = 'totalCanceled',
    documentsByDay = 'documentsByDay',
    invoicesWithoutReceipt = 'invoicesWithoutReceipt',
    noInvoicesEmitted = 'noInvoicesEmitted',
    withoutInvoice = 'withoutInvoice',
    invoiceData = 'invoiceData',
    invoiceDataDisclaimer = 'invoiceDataDisclaimer',
    customTitle = 'customTitle',
    invoiceItemPlaceholdersHelp = 'invoiceItemPlaceholdersHelp',
    customDescription = 'customDescription',
    invoice = 'invoice',
    invoiceReceipt = 'invoiceReceipt',
    simplifiedInvoice = 'simplifiedInvoice',
    creditNote = 'creditNote',
    receipt = 'receipt',
    finalConsumer = 'finalConsumer',
    forbiddenNifError = 'forbiddenNifError',
    useFinalConsumerInstead = 'useFinalConsumerInstead',
    sendInvoiceToClientEmail = 'sendInvoiceToClientEmail',
    sendInvoiceByEmailToClient = 'sendInvoiceByEmailToClient',
    clientEmailRequiredToSendInvoice = 'clientEmailRequiredToSendInvoice',
    sendDocumentByEmail = 'sendDocumentByEmail',
    clientHasNoEmail = 'clientHasNoEmail',
    sendInvoiceBeforeAppointment = 'sendInvoiceBeforeAppointment',
    sendInvoiceDaysBeforeAppointment = 'sendInvoiceDaysBeforeAppointment',
    sendInvoiceBeforeAppointmentTooltip = 'sendInvoiceBeforeAppointmentTooltip',
    sendReceiptOnPayment = 'sendReceiptOnPayment',
    sendReceiptOnPaymentHelp = 'sendReceiptOnPaymentHelp',
    sendReceiptOnPaymentMethods = 'sendReceiptOnPaymentMethods',
    sendReceiptOnPaymentMethodsHelp = 'sendReceiptOnPaymentMethodsHelp',
    sendReceiptOnAllPaymentMethods = 'sendReceiptOnAllPaymentMethods',
    sendReceiptOnOnlinePayments = 'sendReceiptOnOnlinePayments',
    generateInvoicePdfFile = 'generateInvoicePdfFile',
    downloadCreditNotePdf = 'downloadCreditNotePdf',
    invoiceSent = 'invoiceSent',
    invoiceAlreadySent = 'invoiceAlreadySent',
    emailSentToClientOn = 'emailSentToClientOn',
    notPossibleToSendInvoicePleaseConfirmClientEmail = 'notPossibleToSendInvoicePleaseConfirmClientEmail',
    notPossibleToCreateInvoicePleaseConfirmClientData = 'notPossibleToCreateInvoicePleaseConfirmClientData',
    observations = 'observations',
    associatedDocuments = 'associatedDocuments',
    code = 'code',
    quantity = 'quantity',
    unitPrice = 'unitPrice',
    discount = 'discount',
    tax = 'tax',
    draft = 'draft',
    issued = 'issued',
    canceled = 'canceled',
    finalize = 'finalize',
    cancelInvoice = 'cancelInvoice',
    aCreditNoteWillBeIssued = 'aCreditNoteWillBeIssued',
    deleteDraft = 'deleteDraft',
    reason = 'reason',
    exportSaft = 'exportSaft',
    exportInvoicePdfs = 'exportInvoicePdfs',
    invoicePdfsExported = 'invoicePdfsExported',
    year = 'year',
    effective = 'effective',
    paymentsOfDay = 'paymentsOfDay',
    seeDetailsInCashRegister = 'seeDetailsInCashRegister',
    fromAppointments = 'fromAppointments',
    fromPacks = 'fromPacks',
    daySummaryTotalHint = 'daySummaryTotalHint',
    daySummaryEffectiveHint = 'daySummaryEffectiveHint',
    daySummaryPaymentsHint = 'daySummaryPaymentsHint',
    effectivePrice = 'effectivePrice',
    retention = 'retention',
    retained = 'retained',
    left = 'left',
    retentionAnalysisSplitDate = 'retentionAnalysisSplitDate',
    retentionAnalysisDescription = 'retentionAnalysisDescription',
    editableFor = 'editableFor',
    editedAt = 'editedAt',
    minutes = 'minutes',
    notValidYet = 'notValidYet',
    expired = 'expired',
    copiedToClipboard = 'copiedToClipboard',
    inTheNext = 'inTheNext',
    alertWhenAppointmentIsCreated = 'alertWhenAppointmentIsCreated',
    alertWhenAppointmentIsUpdated = 'alertWhenAppointmentIsUpdated',
    alertWhenAppointmentIsCancelled = 'alertWhenAppointmentIsCancelled',
    nextDaySummary = 'nextDaySummary',
    nextDaySummaryForProfessionals = 'nextDaySummaryForProfessionals',
    sendingTime = 'sendingTime',
    willBeSentToAllProfessionals = 'willBeSentToAllProfessionals',

    permanentlyDeleteAllData = 'permanentlyDeleteAllData',
    permanentlyDeleteAllDataConfirmation = 'permanentlyDeleteAllDataConfirmation',
    clientTags = 'clientTags',
    clientTagsHelpNote = 'clientTagsHelpNote',
    addTag = 'addTag',
    lastClientAppointment = 'lastClientAppointment',
    penultimateClientAppointment = 'penultimateClientAppointment',
    startCampaign = 'startCampaign',
    sendXEmails = 'sendXEmails',
    executions = 'executions',
    finished = 'finished',
    error = 'error',
    sending = 'sending',
    failed = 'failed',
    saveAndPrepare = 'saveAndPrepare',
    testOurArtificialAssistant = 'testOurArtificialAssistant',
    retentionQuestion = 'retentionQuestion',
    load = 'load',
    retentionProfessionalMessage = 'retentionProfessionalMessage',
    widthPercentage = 'widthPercentage',
    noInternetMessage = 'noInternetMessage',
    requestTimedOutMessage = 'requestTimedOutMessage',
    service = 'service',
    hour = 'hour',
    firstName = 'firstName',
    lastName = 'lastName',
    mandatory = 'mandatory',
    accept = 'accept',
    personalData = 'personalData',
    avoidCalendarHoles = 'avoidCalendarHoles',
    bookingWindow = 'bookingWindow',
    minimumDaysToSchedule = 'minimumDaysToSchedule',
    maximumDaysToSchedule = 'maximumDaysToSchedule',
    minimumDaysToCancel = 'minimumDaysToCancel',
    minimumDaysToAutoApproveSchedule = 'minimumDaysToAutoApproveSchedule',
    minimumDaysToAutoApproveCancel = 'minimumDaysToAutoApproveCancel',
    selfSchedulingLayout = 'selfSchedulingLayout',
    selfSchedulingLayoutServicesList = 'selfSchedulingLayoutServicesList',
    selfSchedulingLayoutServicesDropdown = 'selfSchedulingLayoutServicesDropdown',
    percentageAmountPaid = 'percentageAmountPaid',
    percentageAppointmentPrice = 'percentageAppointmentPrice',
    clickHereToConfirmAndNotifyTheClient = 'clickHereToConfirmAndNotifyTheClient',
    confirmAndNotifyClientTooltip = 'confirmAndNotifyClientTooltip',
    disableMissingPaymentNotifications = 'disableMissingPaymentNotifications',
    useClientFileNumber = 'useClientFileNumber',
    useClientFileNumberTooltip = 'useClientFileNumberTooltip',
    clientFileNumberLabel = 'clientFileNumberLabel',
    rules = 'rules',
    virtualAssistant = 'virtualAssistant',
    clientSelfSchedulingEmailFlowDescription = 'clientSelfSchedulingEmailFlowDescription',
    sendEmailWhenClientSelfSchedulesAndNotApprovedYet = 'sendEmailWhenClientSelfSchedulesAndNotApprovedYet',
    clientSelfSchedulingPendingApprovalCustomMessage = 'clientSelfSchedulingPendingApprovalCustomMessage',
    clientSelfSchedulingPendingApprovalCustomMessageHelp = 'clientSelfSchedulingPendingApprovalCustomMessageHelp',
    clientSelfSchedulingPendingApprovalCustomMessagePlaceholders = 'clientSelfSchedulingPendingApprovalCustomMessagePlaceholders',
    clientSelfSchedulingEmailPreviewTitle = 'clientSelfSchedulingEmailPreviewTitle',
    clientSelfSchedulingEmailPreviewApprovedTitle = 'clientSelfSchedulingEmailPreviewApprovedTitle',
    clientSelfSchedulingEmailPreviewPendingTitle = 'clientSelfSchedulingEmailPreviewPendingTitle',
    clientSelfSchedulingEmailPreviewPersonalizationLine = 'clientSelfSchedulingEmailPreviewPersonalizationLine',
    clientSelfSchedulingEmailPreviewPlaceholder = 'clientSelfSchedulingEmailPreviewPlaceholder',
    clientSelfSchedulingEmailPreviewShow = 'clientSelfSchedulingEmailPreviewShow',
    clientSelfSchedulingEmailPreviewHide = 'clientSelfSchedulingEmailPreviewHide',
    appointmentConfirmedClientEmailSubject = 'appointmentConfirmedClientEmailSubject',
    appointmentConfirmedClientEmailBody = 'appointmentConfirmedClientEmailBody',
    appointmentPendingApprovalClientEmailGreeting = 'appointmentPendingApprovalClientEmailGreeting',
    appointmentPendingApprovalClientEmailBody = 'appointmentPendingApprovalClientEmailBody',
    appointmentPendingApprovalClientEmailClosing = 'appointmentPendingApprovalClientEmailClosing',
    appointmentPendingApprovalClientEmailThanks = 'appointmentPendingApprovalClientEmailThanks',
    verifyYourEmailInbox = 'verifyYourEmailInbox',
    prices = 'prices',
    inactivityNotificationAfter = 'inactivityNotificationAfter',
    byClient = 'byClient',
    average = 'average',
    appointmentsWith = 'appointmentsWith',
    clientsWithAppointmentsOf = 'clientsWithAppointmentsOf',
    addFilter = 'addFilter',
    invertFilterResult = 'invertFilterResult',
    appointmentsDone = 'appointmentsDone',
    appointmentsNotDone = 'appointmentsNotDone',
    appointmentsFree = 'appointmentsFree',
    appointmentsNotFree = 'appointmentsNotFree',
    appointmentsWithInvoice = 'appointmentsWithInvoice',
    appointmentsWithReceipt = 'appointmentsWithReceipt',
    appointmentsWithoutInvoice = 'appointmentsWithoutInvoice',
    appointmentsWithoutReceipt = 'appointmentsWithoutReceipt',
    appointmentsConfirmedByClient = 'appointmentsConfirmedByClient',
    appointmentsNotConfirmedByClient = 'appointmentsNotConfirmedByClient',
    appointmentsRecurring = 'appointmentsRecurring',
    appointmentsNotRecurring = 'appointmentsNotRecurring',
    appointmentsPaidWithPack = 'appointmentsPaidWithPack',
    or = 'or',
    filters = 'filters',
    showCount = 'showCount',
    operatingMargin = 'operatingMargin',
    operatingMarginPercent = 'operatingMarginPercent',
    excludeZeroValueAppointments = 'excludeZeroValueAppointments',
    startDate = 'startDate',
    endDate = 'endDate',
    period = 'period',
    recurring = 'recurring',
    notRecurring = 'notRecurring',

    holidayPeriods = 'holidayPeriods',
    weeks = 'weeks',
    months = 'months',
    never = 'never',
    forever = 'forever',
    unit = 'unit',
    frequency = 'frequency',
    daily = 'daily',
    weekly = 'weekly',
    monthly = 'monthly',
    weekDays = 'weekDays',
    recurringEditQuestion = 'recurringEditQuestion',
    recurringDeleteQuestion = 'recurringDeleteQuestion',
    thisEventOnly = 'thisEventOnly',
    thisAndFollowingEvents = 'thisAndFollowingEvents',
    recurringLimitExceeded = 'recurringLimitExceeded',
    recurringCreatedSummary = 'recurringCreatedSummary',
    recurringCreatedSummaryWithLastDate = 'recurringCreatedSummaryWithLastDate',
    dueToPackCreditsExhaustion = 'dueToPackCreditsExhaustion',
    startTime = 'startTime',
    endTime = 'endTime',
    optional = 'optional',
    goHighLevelPrivateIntegrationKeyLabel = 'goHighLevelPrivateIntegrationKeyLabel',
    goHighLevelLocationIdLabel = 'goHighLevelLocationIdLabel',
    goHighLevelLocationIdHelp = 'goHighLevelLocationIdHelp',
    goHighLevelPrivateKeyHelp = 'goHighLevelPrivateKeyHelp',
    goHighLevelNotConfigured = 'goHighLevelNotConfigured',
    goHighLevelCalendarSetupFailed = 'goHighLevelCalendarSetupFailed',
    goHighLevelSyncUnexpectedError = 'goHighLevelSyncUnexpectedError',
    goHighLevelSyncSuccess = 'goHighLevelSyncSuccess',
    goHighLevelClearSuccess = 'goHighLevelClearSuccess',
    goHighLevelClearUnexpectedError = 'goHighLevelClearUnexpectedError',
    goHighLevelSyncConfirmationTitle = 'goHighLevelSyncConfirmationTitle',
    goHighLevelSyncConfirmationMessage = 'goHighLevelSyncConfirmationMessage',
    goHighLevelSyncTooSoon = 'goHighLevelSyncTooSoon',
    syncingInProgress = 'syncingInProgress',
    goHighLevelClearConfirmationTitle = 'goHighLevelClearConfirmationTitle',
    goHighLevelClearConfirmationMessage = 'goHighLevelClearConfirmationMessage',
    sync = 'sync',
    syncing = 'syncing',
    goHighLevelSyncCalendars = 'goHighLevelSyncCalendars',
    clear = 'clear',
    clearing = 'clearing',
    testing = 'testing',
    deleteAll = 'deleteAll',
    deletingAll = 'deletingAll',
    goHighLevelDeleteAllTooltip = 'goHighLevelDeleteAllTooltip',
    goHighLevelContactSupportToUse = 'goHighLevelContactSupportToUse',
    goHighLevelIntegrationDescription = 'goHighLevelIntegrationDescription',
    goHighLevelCreateCalendarPerServiceType = 'goHighLevelCreateCalendarPerServiceType',
    goHighLevelCreateCalendarPerServiceTypeTooltip = 'goHighLevelCreateCalendarPerServiceTypeTooltip',
    goHighLevelAssociateProfessionals = 'goHighLevelAssociateProfessionals',
    goHighLevelAssociateProfessionalsHelp = 'goHighLevelAssociateProfessionalsHelp',
    goHighLevelProfessionalUserMappingTitle = 'goHighLevelProfessionalUserMappingTitle',
    goHighLevelProfessionalColumn = 'goHighLevelProfessionalColumn',
    goHighLevelGhlUserColumn = 'goHighLevelGhlUserColumn',
    goHighLevelNotMapped = 'goHighLevelNotMapped',
    goHighLevelLoadingUsers = 'goHighLevelLoadingUsers',
    goHighLevelLoadGhlUsersFailed = 'goHighLevelLoadGhlUsersFailed',
    goHighLevelActivityLog = 'goHighLevelActivityLog',
    goHighLevelActivityLogEmpty = 'goHighLevelActivityLogEmpty',
    goHighLevelActivityLogLoadError = 'goHighLevelActivityLogLoadError',
    goHighLevelActivityLogLevel = 'goHighLevelActivityLogLevel',
    goHighLevelActivityLogEntityType = 'goHighLevelActivityLogEntityType',
    goHighLevelActivityLogContext = 'goHighLevelActivityLogContext',
    goHighLevelActivityLogMessage = 'goHighLevelActivityLogMessage',
    goHighLevelActivityLogTimestamp = 'goHighLevelActivityLogTimestamp',
    goHighLevelActivityLogLoadMore = 'goHighLevelActivityLogLoadMore',
    mailerLite = 'mailerLite',
    mailerLiteIntegrationDescription = 'mailerLiteIntegrationDescription',
    mailerLiteApiKeyLabel = 'mailerLiteApiKeyLabel',
    mailerLiteApiKeyHelp = 'mailerLiteApiKeyHelp',
    mailerLiteTestApiKey = 'mailerLiteTestApiKey',
    mailerLiteApiKeyValidated = 'mailerLiteApiKeyValidated',
    mailerLiteStepApiKeyTitle = 'mailerLiteStepApiKeyTitle',
    mailerLiteStepMappingTitle = 'mailerLiteStepMappingTitle',
    mailerLiteFieldMappingDescription = 'mailerLiteFieldMappingDescription',
    mailerLiteFieldMappingHint = 'mailerLiteFieldMappingHint',
    mailerLiteTagPrefixDescription = 'mailerLiteTagPrefixDescription',
    mailerLiteDuplicateMappingError = 'mailerLiteDuplicateMappingError',
    mailerLiteNoFieldsFound = 'mailerLiteNoFieldsFound',
    mailerLiteTableMailerLiteField = 'mailerLiteTableMailerLiteField',
    mailerLiteTableMappingType = 'mailerLiteTableMappingType',
    mailerLiteTableAppointmintField = 'mailerLiteTableAppointmintField',
    mailerLiteNoMappingOption = 'mailerLiteNoMappingOption',
    mailerLiteMappingTypeNone = 'mailerLiteMappingTypeNone',
    mailerLiteMappingTypeProfileField = 'mailerLiteMappingTypeProfileField',
    mailerLiteMappingTypeClientTagPrefix = 'mailerLiteMappingTypeClientTagPrefix',
    mailerLiteTagPrefixLabel = 'mailerLiteTagPrefixLabel',
    mailerLiteTagPrefixHelp = 'mailerLiteTagPrefixHelp',
    mailerLiteAppointmintFieldName = 'mailerLiteAppointmintFieldName',
    mailerLiteAppointmintFieldEmail = 'mailerLiteAppointmintFieldEmail',
    mailerLiteAppointmintFieldPhoneNumbers = 'mailerLiteAppointmintFieldPhoneNumbers',
    mailerLiteAppointmintFieldBirthday = 'mailerLiteAppointmintFieldBirthday',
    mailerLiteAppointmintFieldSex = 'mailerLiteAppointmintFieldSex',
    mailerLiteAppointmintFieldJob = 'mailerLiteAppointmintFieldJob',
    mailerLiteAppointmintFieldOrigin = 'mailerLiteAppointmintFieldOrigin',
    mailerLiteAppointmintFieldTaxNumber = 'mailerLiteAppointmintFieldTaxNumber',
    mailerLiteAppointmintFieldHealthNumber = 'mailerLiteAppointmintFieldHealthNumber',
    mailerLiteAppointmintFieldSubsystemName = 'mailerLiteAppointmintFieldSubsystemName',
    mailerLiteAppointmintFieldSubsystemNumber = 'mailerLiteAppointmintFieldSubsystemNumber',
    mailerLiteAppointmintFieldAddressLine1 = 'mailerLiteAppointmintFieldAddressLine1',
    mailerLiteAppointmintFieldAddressLine2 = 'mailerLiteAppointmintFieldAddressLine2',
    mailerLiteAppointmintFieldZipCode = 'mailerLiteAppointmintFieldZipCode',
    mailerLiteAppointmintFieldCity = 'mailerLiteAppointmintFieldCity',
    mailerLiteAppointmintFieldNotes = 'mailerLiteAppointmintFieldNotes',
    mailerLiteImportSectionTitle = 'mailerLiteImportSectionTitle',
    mailerLiteImportDescription = 'mailerLiteImportDescription',
    mailerLiteImportSaveChangesFirst = 'mailerLiteImportSaveChangesFirst',
    mailerLiteImportButton = 'mailerLiteImportButton',
    mailerLiteImportCompletedAt = 'mailerLiteImportCompletedAt',
    mailerLiteImportConfirmationTitle = 'mailerLiteImportConfirmationTitle',
    mailerLiteImportConfirmationMessage = 'mailerLiteImportConfirmationMessage',
    mailerLiteImportInProgress = 'mailerLiteImportInProgress',
    mailerLiteImportCreateIfNotExists = 'mailerLiteImportCreateIfNotExists',
    mailerLiteImportCreateIfNotExistsHelp = 'mailerLiteImportCreateIfNotExistsHelp',
    mailerLiteTagPrefixHelpText = 'mailerLiteTagPrefixHelpText',
    continueButton = 'continue',
    integrationSyncInitiated = 'integrationSyncInitiated',
    integrationClearInitiated = 'integrationClearInitiated',
    refresh = 'refresh',
    syncStatisticsTitle = 'syncStatisticsTitle',
    lastFullSync = 'lastFullSync',
    lastSync = 'lastSync',
    totalClientsSynced = 'totalClientsSynced',
    totalAppointmentsSynced = 'totalAppointmentsSynced',
    settingsReloaded = 'settingsReloaded',
    expenseTypes = 'expenseTypes',
    expenseType = 'expenseType',
    dontGroup = 'dontGroup',
    income = 'income',
    outcome = 'outcome',
    global = 'global',
    byPaymentType = 'byPaymentType',
    byExpenseName = 'byExpenseName',
    byExpenseType = 'byExpenseType',
    vat = 'vat',
    withoutVAT = 'withoutVAT',
    withVAT = 'withVAT',
    withoutComission = 'withoutComission',
    comission = 'comission',
    commissions = 'commissions',
    minComission = 'minComission',
    netComission = 'netComission',
    history = 'history',
    issueInvoice = 'issueInvoice',
    emit = 'emit',
    emitReceipt = 'emitReceipt',
    seeReceipt = 'seeReceipt',
    receiptWillBeCreated = 'receiptWillBeCreated',
    receiptEmitted = 'receiptEmitted',
    confirmReceiptEmission = 'confirmReceiptEmission',
    sendInvoicesAutomaticallyToClientsByEmail = 'sendInvoicesAutomaticallyToClientsByEmail',
    sendSaftReportAutomaticallyToAT = 'sendSaftReportAutomaticallyToAT',
    sendSaftReportAutomaticallyToATHelp = 'sendSaftReportAutomaticallyToATHelp',
    emitInvoiceAutomaticallyOnPaymentConfirmation = 'emitInvoiceAutomaticallyOnPaymentConfirmation',
    addAppointmentPackDetailsAutomaticallyOnInvoice = 'addAppointmentPackDetailsAutomaticallyOnInvoice',
    appointmentPackDetailsTemplate = 'appointmentPackDetailsTemplate',
    appointmentPackDetailsTemplatePlaceholdersNote = 'appointmentPackDetailsTemplatePlaceholdersNote',
    billingModuleNotActivatedMessage = 'billingModuleNotActivatedMessage',

    // Invoices settings (providers)
    provider = 'provider',
    yourBillingSystem = 'yourBillingSystem',
    select = 'select',
    selectProduct = 'selectProduct',
    emptyEntry = 'emptyEntry',
    selectClientFirst = 'selectClientFirst',
    configureAtcud = 'configureAtcud',
    atUsername = 'atUsername',
    atUsernameHelp = 'atUsernameHelp',
    atFiscalId = 'atFiscalId',
    atSetupSectionTitle = 'atSetupSectionTitle',
    invoicesSettingsTabLabel = 'invoicesSettingsTabLabel',
    saveCredentials = 'saveCredentials',
    atIntegrationConfigured = 'atIntegrationConfigured',
    atIntegrationNotConfigured = 'atIntegrationNotConfigured',
    accountName = 'accountName',
    activateSimulateMode = 'activateSimulateMode',
    simulationModeActiveNotice = 'simulationModeActiveNotice',
    simulateModeTooltip = 'simulateModeTooltip',
    invoiceBranchMappingsTitle = 'invoiceBranchMappingsTitle',
    invoiceBranchMappingsDescription = 'invoiceBranchMappingsDescription',
    invoiceBranchProvisioned = 'invoiceBranchProvisioned',
    invoiceBranchProvisioningPending = 'invoiceBranchProvisioningPending',
    invoiceBranchLegacyFallback = 'invoiceBranchLegacyFallback',
    syncBranchStores = 'syncBranchStores',
    syncBranchStoresHelp = 'syncBranchStoresHelp',
    appointmintManagedInvoicesTitle = 'appointmintManagedInvoicesTitle',
    appointmintManagedInvoicesMessage = 'appointmintManagedInvoicesMessage',
    cegidVendusMissingFields = 'cegidVendusMissingFields',
    activatedAtLabel = 'activatedAtLabel',
    notActivatedYet = 'notActivatedYet',
    sendMbWayRequestToClient = 'sendMbWayRequestToClient',
    sendMbRequestToClient = 'sendMbRequestToClient',
    sendCheckoutLinkToClientEmail = 'sendCheckoutLinkToClientEmail',
    cashRegisterAddPayment = 'cashRegisterAddPayment',
    addManualPayment = 'addManualPayment',
    manual = 'manual',
    purchase = 'purchase',
    update = 'update',
    taxId = 'taxId',
    invoiceDefaultTaxInfo = 'invoiceDefaultTaxInfo',
    itemType = 'itemType',
    taxExemption = 'taxExemption',
    taxExemptionLaw = 'taxExemptionLaw',
    groupAppointment = 'groupAppointment',
    serviceNameNotes = 'serviceNameNotes',
    serviceCategoryNotes = 'serviceCategoryNotes',
    serviceNameAlreadyExists = 'serviceNameAlreadyExists',
    serviceDurationNotes = 'serviceDurationNotes',
    serviceGroupNotes = 'serviceGroupNotes',
    serviceDescriptionNotes = 'serviceDescriptionNotes',
    serviceRoomsNotes = 'serviceRoomsNotes',
    emitStandaloneInvoice = 'emitStandaloneInvoice',
    invoicesEmitted = 'invoicesEmitted',
    paymentsReceived = 'paymentsReceived',
    selectClient = 'selectClient',
    pleaseConfigureInvoiceSettingsFirst = 'pleaseConfigureInvoiceSettingsFirst',
    invoiceItemCodeRequired = 'invoiceItemCodeRequired',
    openingHour = 'openingHour',
    closingHour = 'closingHour',
    generalInvoiceObservations = 'generalInvoiceObservations',
    defaultInvoicePaymentMethod = 'defaultInvoicePaymentMethod',
    defaultInvoicePaymentMethodHelp = 'defaultInvoicePaymentMethodHelp',
    otherAttributes = 'otherAttributes',
    reportTableOptionsNote = 'reportTableOptionsNote',
    country = 'country',
    portugal = 'portugal',
    france = 'france',
    subscription = 'subscription',
    subscriptions = 'subscriptions',
    packBySubscriptionDescription = 'packBySubscriptionDescription',
    paymentPeriod = 'paymentPeriod',
    openAppointment = 'openAppointment',
    openPack = 'openPack',
    makeItRecurring = 'makeItRecurring',
    you = 'you',
    typeYourEmailMessage = 'typeYourEmailMessage',
    typeYourSmsMessage = 'typeYourSmsMessage',
    typeYourWhatsAppMessage = 'typeYourWhatsAppMessage',
    whatsappTemplateRequiredBadge = 'whatsappTemplateRequiredBadge',
    whatsappTemplate = 'whatsappTemplate',
    whatsappTemplates = 'whatsappTemplates',
    whatsappTemplatesDescription = 'whatsappTemplatesDescription',
    whatsappTemplatesNoCampaignTemplates = 'whatsappTemplatesNoCampaignTemplates',
    whatsappTemplatesOpenSettings = 'whatsappTemplatesOpenSettings',
    whatsappTemplatesSync = 'whatsappTemplatesSync',
    whatsappTemplatesCreate = 'whatsappTemplatesCreate',
    whatsappTemplateBody = 'whatsappTemplateBody',
    whatsappTemplateHeader = 'whatsappTemplateHeader',
    whatsappTemplateFooter = 'whatsappTemplateFooter',
    whatsappTemplateNameHint = 'whatsappTemplateNameHint',
    whatsappTemplateVariablesHint = 'whatsappTemplateVariablesHint',
    whatsappTemplateCreateSuccess = 'whatsappTemplateCreateSuccess',
    whatsappTemplateUpdateSuccess = 'whatsappTemplateUpdateSuccess',
    whatsappTemplateDeleteSuccess = 'whatsappTemplateDeleteSuccess',
    whatsappTemplateDeleteConfirm = 'whatsappTemplateDeleteConfirm',
    whatsappTemplateMetaApprovalDisclaimer = 'whatsappTemplateMetaApprovalDisclaimer',
    whatsappTemplateCategoryMarketing = 'whatsappTemplateCategoryMarketing',
    whatsappTemplateCategoryUtility = 'whatsappTemplateCategoryUtility',
    whatsappTemplateCategoryHint = 'whatsappTemplateCategoryHint',
    whatsappTemplateStatusApproved = 'whatsappTemplateStatusApproved',
    whatsappTemplateStatusRejected = 'whatsappTemplateStatusRejected',
    whatsappTemplateStatusPending = 'whatsappTemplateStatusPending',
    whatsappTemplateStatusDisabled = 'whatsappTemplateStatusDisabled',
    whatsappTemplateStatusPaused = 'whatsappTemplateStatusPaused',
    whatsappTemplateCannotEdit = 'whatsappTemplateCannotEdit',
    whatsappTemplateApprovedCannotEdit = 'whatsappTemplateApprovedCannotEdit',
    sentSuccessfully = 'sentSuccessfully',
    onlyEmailCommunicationSupported = 'onlyEmailCommunicationSupported',
    attachFiles = 'attachFiles',
    segments = 'segments',
    automatic = 'automatic',
    reply = 'reply',
    replyingTo = 'replyingTo',
    markAsRead = 'markAsRead',
    markAsUnread = 'markAsUnread',
    receivedAt = 'receivedAt',
    readBy = 'readBy',
    branch = 'branch',
    branches = 'branches',
    branchesHelpNote = 'branchesHelpNote',
    allBranches = 'allBranches',
    noBranch = 'noBranch',
    appointmentsMustBelongToSameBranch = 'appointmentsMustBelongToSameBranch',

    // Subscription UI labels
    perMonth = 'perMonth',
    activate = 'activate',
    activated = 'activated',
    addonsAvailable = 'addonsAvailable',
    mySubscription = 'mySubscription',
    operationalCore = 'operationalCore',
    intelligence = 'intelligence',
    growth = 'growth',
    basePlan = 'basePlan',
    proPlan = 'proPlan',
    proPlusPlan = 'proPlusPlan',
    usersIncluded = 'usersIncluded',
    emailsIncluded = 'emailsIncluded',
    smsIncluded = 'smsIncluded',
    totalEmails = 'totalEmails',
    clientsCrm = 'clientsCrm',
    calendarScheduling = 'calendarScheduling',
    packsMemberships = 'packsMemberships',
    stockProducts = 'stockProducts',
    analytics = 'analytics',
    analyticsDescription = 'analyticsDescription',
    hoursAnalyticsDescription = 'hoursAnalyticsDescription',
    countAnalyticsDescription = 'countAnalyticsDescription',
    retentionAnalyticsDescription = 'retentionAnalyticsDescription',
    cancellationsAnalyticsDescription = 'cancellationsAnalyticsDescription',
    ocupancyAnalyticsDescription = 'ocupancyAnalyticsDescription',
    surveysAnalyticsDescription = 'surveysAnalyticsDescription',
    waitingListsAnalyticsDescription = 'waitingListsAnalyticsDescription',
    reportsDescription = 'reportsDescription',
    accountingExpenses = 'accountingExpenses',
    accountingDescription = 'accountingDescription',
    campaignsMarketing = 'campaignsMarketing',
    campaignsDescription = 'campaignsDescription',
    multipleDelegations = 'multipleDelegations',
    multipleDelegationsDescription = 'multipleDelegationsDescription',
    billingAddon = 'billingAddon',
    billingAddonDescription = 'billingAddonDescription',
    storageAddon = 'storageAddon',
    storageAddonDescription = 'storageAddonDescription',
    mintuAddon = 'mintuAddon',
    mintuAddonDescription = 'mintuAddonDescription',
    integrationsAddon = 'integrationsAddon',
    integrationsAddonDescription = 'integrationsAddonDescription',
    whatsAppAddon = 'whatsAppAddon',
    whatsAppAddonDescription = 'whatsAppAddonDescription',
    availableOnAllPlans = 'availableOnAllPlans',
    totalPrice = 'totalPrice',
    numberOfActiveUsers = 'numberOfActiveUsers',
    monthlySmsBundle = 'monthlySmsBundle',
    monthlyEmailBundle = 'monthlyEmailBundle',
    monthlyWhatsAppBundle = 'monthlyWhatsAppBundle',
    extraStorage = 'extraStorage',
    perExtraUser = 'perExtraUser',
    clientsCrmDescription = 'clientsCrmDescription',
    professionalsDescription = 'professionalsDescription',
    calendarSchedulingDescription = 'calendarSchedulingDescription',
    packsMembershipsDescription = 'packsMembershipsDescription',
    stockProductsDescription = 'stockProductsDescription',
    paymentsDescription = 'paymentsDescription',
    remindersDescription = 'remindersDescription',
    none = 'none',
    included = 'included',
    myPacks = 'myPacks',
    subscriptionPlanBasicTagline = 'subscriptionPlanBasicTagline',
    subscriptionPlanProTagline = 'subscriptionPlanProTagline',
    subscriptionPlanProPlusTagline = 'subscriptionPlanProPlusTagline',
    billedAnnually = 'billedAnnually',
    billedMonthly = 'billedMonthly',
    yourCurrentPlan = 'yourCurrentPlan',
    currentSubscriptionOverview = 'currentSubscriptionOverview',
    currentPlan = 'currentPlan',
    monthlyTotal = 'monthlyTotal',
    lastPaymentDate = 'lastPaymentDate',
    nextPaymentDate = 'nextPaymentDate',
    viewInvoices = 'viewInvoices',
    viewInvoicesAndPayments = 'viewInvoicesAndPayments',
    viewInvoice = 'viewInvoice',
    cancelSubscription = 'cancelSubscription',
    upgradeSubscription = 'upgradeSubscription',
    subscriptionUpgraded = 'subscriptionUpgraded',
    failedToUpgradeSubscription = 'failedToUpgradeSubscription',
    subscriptionChangesSupportMessage = 'subscriptionChangesSupportMessage',
    notAvailable = 'notAvailable',
    current = 'current',
    afterChanges = 'afterChanges',
    validUntil = 'validUntil',
    reference = 'reference',
    currentPrice = 'currentPrice',
    newPrice = 'newPrice',
    noChanges = 'noChanges',
    savingsPerMonth = 'savingsPerMonth',
    increasePerMonth = 'increasePerMonth',
    yearly = 'yearly',
    currentlyPaying = 'currentlyPaying',
    difference = 'difference',
    newPlan = 'newPlan',
    failedToLoadSubscriptionData = 'failedToLoadSubscriptionData',
    pleaseRetryLater = 'pleaseRetryLater',
    storageUnit = 'storageUnit',
    helpAndFaq = 'helpAndFaq',
    subscriptionHistory = 'subscriptionHistory',
    noSubscriptionsFound = 'noSubscriptionsFound',
    validTo = 'validTo',
    noExtras = 'noExtras',
    every = 'every',
    attachments = 'attachments',
    addFile = 'addFile',
    noAttachments = 'noAttachments',
    noUnreadMessages = 'noUnreadMessages',
    markAllAsRead = 'markAllAsRead',
    unreadMessages = 'unreadMessages',
    recentMessages = 'recentMessages',
    noRecentMessages = 'noRecentMessages',
    whatsApp = 'whatsApp',
    permissionAdministratorDescription = 'permissionAdministratorDescription',
    permissionPricesAccessDescription = 'permissionPricesAccessDescription',
    permissionPricesManagementDescription = 'permissionPricesManagementDescription',
    permissionProfessionalsManagementDescription = 'permissionProfessionalsManagementDescription',
    permissionClientsAccessDescription = 'permissionClientsAccessDescription',
    permissionClientsReportsDescription = 'permissionClientsReportsDescription',
    permissionClientsManagementDescription = 'permissionClientsManagementDescription',
    permissionAppointmentsAccessDescription = 'permissionAppointmentsAccessDescription',
    permissionAppointmentsManagementDescription = 'permissionAppointmentsManagementDescription',
    permissionCampaignsManagementDescription = 'permissionCampaignsManagementDescription',
    permissionAnalyticsDescription = 'permissionAnalyticsDescription',
    permissionProfessionalDescription = 'permissionProfessionalDescription',
    permissionMyClientsManagementDescription = 'permissionMyClientsManagementDescription',
    permissionClientsChatDescription = 'permissionClientsChatDescription',
    busy = 'busy',
    cannotDeleteAppointmentWithPaymentsOrInvoices = 'cannotDeleteAppointmentWithPaymentsOrInvoices',
    cannotChangeAppointmentTypeWithActiveInvoices = 'cannotChangeAppointmentTypeWithActiveInvoices',
    reasonForChange = 'reasonForChange',
    organization = 'organization',
    other = 'other',
    pleaseProvideAReason = 'pleaseProvideAReason',
    reasonType = 'reasonType',
    reasonDetails = 'reasonDetails',
    inProgress = 'inProgress',
    consentManagement = 'consentManagement',
    termsAndConditionsLink = 'termsAndConditionsLink',
    privacyPolicyLink = 'privacyPolicyLink',
    consentCheckboxes = 'consentCheckboxes',
    defaultCheckbox = 'defaultCheckbox',
    systemDefault = 'systemDefault',
    customCheckbox = 'customCheckbox',
    checkboxName = 'checkboxName',
    checkboxNamePlaceholder = 'checkboxNamePlaceholder',
    checkboxText = 'checkboxText',
    checkboxTextPlaceholder = 'checkboxTextPlaceholder',
    mandatoryConsent = 'mandatoryConsent',
    consents = 'consents',
    consentsPlaceholder = 'consentsPlaceholder',
    consentsHelpText = 'consentsHelpText',
    addConsent = 'addConsent',
    noConsentsEnabled = 'noConsentsEnabled',
    links = 'links',
    addLink = 'addLink',
    addCustomCheckbox = 'addCustomCheckbox',
    addConsentCheckbox = 'addConsentCheckbox',
    clickToEdit = 'clickToEdit',
    inlineEditHint = 'inlineEditHint',
    consentManagementPageExplanation = 'consentManagementPageExplanation',
    consentPreviewHint = 'consentPreviewHint',
    consentManagementGlobalLinks = 'consentManagementGlobalLinks',
    consentManagementGlobalLinksDescription = 'consentManagementGlobalLinksDescription',
    consentCheckboxPreview = 'consentCheckboxPreview',
    linkLabel = 'linkLabel',
    linkUrl = 'linkUrl',
    linkLabelPlaceholder = 'linkLabelPlaceholder',
    linkUrlPlaceholder = 'linkUrlPlaceholder',
    editCheckbox = 'editCheckbox',

    // Individual consent types
    consentGDPR = 'consentGDPR',
    consentHealthDataProcessing = 'consentHealthDataProcessing',
    consentEmailMarketing = 'consentEmailMarketing',
    consentSMSMarketing = 'consentSMSMarketing',
    consentBirthdayMessage = 'consentBirthdayMessage',
    consentEmailReminders = 'consentEmailReminders',
    consentSMSReminders = 'consentSMSReminders',
    consentWhatsAppReminders = 'consentWhatsAppReminders',
    consentDataSharingWithProfessionals = 'consentDataSharingWithProfessionals',
    consentThirdPartyDataSharing = 'consentThirdPartyDataSharing',
    consentImageOrVideoCaptureForInstitutionalPurposes = 'consentImageOrVideoCaptureForInstitutionalPurposes',
    essentialConsents = 'essentialConsents',
    marketingConsents = 'marketingConsents',
    consentDefaultName = 'consentDefaultName',
    essentialConsentsCheckboxText = 'essentialConsentsCheckboxText',
    marketingConsentsCheckboxText = 'marketingConsentsCheckboxText',

    // Physical consent upload
    downloadConsentPdf = 'downloadConsentPdf',
    uploadPhysicalConsent = 'uploadPhysicalConsent',
    uploadPhysicalConsentDescription = 'uploadPhysicalConsentDescription',
    uploadPhysicalConsentFile = 'uploadPhysicalConsentFile',
    consentPhysicalUploadSuccess = 'consentPhysicalUploadSuccess',
    markConsentApprovals = 'markConsentApprovals',

    // Consent UI helpers
    consentsAssumedByDefault = 'consentsAssumedByDefault',
    resendConsentRequest = 'resendConsentRequest',
    approvedOn = 'approvedOn',
    sendConsentViaEmail = 'sendConsentViaEmail',
    sendConsentViaWhatsApp = 'sendConsentViaWhatsApp',
    sendConsentViaSms = 'sendConsentViaSms',
    consentRequestSent = 'consentRequestSent',

    number = 'number',

    // Invoice payment validation
    invoiceValueMismatch = 'invoiceValueMismatch',
    invoiceTotalValue = 'invoiceTotalValue',
    originalAppointmentPackValue = 'originalAppointmentPackValue',
    valueDifference = 'valueDifference',
    selectPaymentMethod = 'selectPaymentMethod',
    selectPaymentMethodForDifference = 'selectPaymentMethodForDifference',
    continueWithInvoiceEmission = 'continueWithInvoiceEmission',
    invoiceReceiptRequiresPaymentMethod = 'invoiceReceiptRequiresPaymentMethod',
    appointmentPackMustBePaidBeforeInvoiceReceipt = 'appointmentPackMustBePaidBeforeInvoiceReceipt',
    paymentInProgressWarning = 'paymentInProgressWarning',
    paymentsConsideredForInvoice = 'paymentsConsideredForInvoice',
    appointmentPackNotPaidYet = 'appointmentPackNotPaidYet',
    via = 'via',

    // Appointment changes
    changeType = 'changeType',
    changes = 'changes',
    dateChanged = 'dateChanged',
    clientChanged = 'clientChanged',
    changeOrigin = 'changeOrigin',
    newDate = 'newDate',
    newClient = 'newClient',
    with = 'with',
    cancellations = 'cancellations',
    cancelled = 'cancelled',
    groupBy = 'groupBy',
    cancellationAnalyticsDescription = 'cancellationAnalyticsDescription',
    rebooked = 'rebooked',

    // Login page
    signIn = 'signIn',
    signInAsProfessional = 'signInAsProfessional',
    signInAsClient = 'signInAsClient',
    yourEmail = 'yourEmail',
    yourPassword = 'yourPassword',
    dontHaveAccount = 'dontHaveAccount',
    register = 'register',
    forgotPassword = 'forgotPassword',
    createAccount = 'createAccount',
    createAccountWithGoogle = 'createAccountWithGoogle',
    continueWithGoogle = 'continueWithGoogle',
    switchToClient = 'switchToClient',
    switchToProfessional = 'switchToProfessional',
    switchToListMode = 'switchToListMode',
    switchToTextMode = 'switchToTextMode',
    addItem = 'addItem',
    selectYourRole = 'selectYourRole',
    loginAsProfessional = 'loginAsProfessional',
    loginAsClient = 'loginAsClient',
    welcomeToAppointmint = 'welcomeToAppointmint',
    letsSetupYourAccount = 'letsSetupYourAccount',
    startYour30DayTrial = 'startYour30DayTrial',
    companyNamePlaceholder = 'companyNamePlaceholder',
    companyNameRequired = 'companyNameRequired',
    companyNameTooShort = 'companyNameTooShort',
    companyNameTooLong = 'companyNameTooLong',
    servicesProvided = 'servicesProvided',
    servicesOptionalDescription = 'servicesOptionalDescription',
    servicesProvidedPlaceholder = 'servicesProvidedPlaceholder',
    addService = 'addService',
    removeService = 'removeService',
    atLeastOneService = 'atLeastOneService',
    professionalEmails = 'professionalEmails',
    professionalEmailsOptionalDescription = 'professionalEmailsOptionalDescription',
    professionalEmailsPlaceholder = 'professionalEmailsPlaceholder',
    notifyProfessionalsByEmail = 'notifyProfessionalsByEmail',
    notifyProfessionalsByEmailDescription = 'notifyProfessionalsByEmailDescription',
    addProfessional = 'addProfessional',
    removeProfessional = 'removeProfessional',
    atLeastOneProfessional = 'atLeastOneProfessional',
    maxProfessionalsReached = 'maxProfessionalsReached',
    step = 'step',
    finish = 'finish',
    creatingYourAccount = 'creatingYourAccount',
    accountCreated = 'accountCreated',
    signUpEmailPasswordRequired = 'signUpEmailPasswordRequired',
    selectYourBusiness = 'selectYourBusiness',
    selectYourUser = 'selectYourUser',
    youHaveMultipleBusinesses = 'youHaveMultipleBusinesses',
    pleaseSelectOne = 'pleaseSelectOne',
    noAssociatedClinics = 'noAssociatedClinics',
    youHaveNoAssociatedClinics = 'youHaveNoAssociatedClinics',
    pleaseContactClinic = 'pleaseContactClinic',
    askClinicForAccess = 'askClinicForAccess',
    createBusiness = 'createBusiness',
    noClinicsExplanation = 'noClinicsExplanation',
    failedToCompleteOnboarding = 'failedToCompleteOnboarding',
    setupAdminCredentials = 'setupAdminCredentials',
    passwordsDoNotMatch = 'passwordsDoNotMatch',
    passwordTooShort = 'passwordTooShort',
    addMoreDetailsLater = 'addMoreDetailsLater',
    yourServices = 'yourServices',
    yourRooms = 'yourRooms',
    addCustomService = 'addCustomService',
    addCustomRoom = 'addCustomRoom',
    servicesRoomsQuickSetup = 'servicesRoomsQuickSetup',
    servicesSuggestionsLabel = 'servicesSuggestionsLabel',
    servicePricePlaceholder = 'servicePricePlaceholder',
    pvpPriceOptional = 'pvpPriceOptional',
    roomsOptionalDescription = 'roomsOptionalDescription',
    roomsSuggestionsLabel = 'roomsSuggestionsLabel',
    roomPlaceholder = 'roomPlaceholder',
    addRoom = 'addRoom',
    removeRoom = 'removeRoom',
    atLeastOneRoom = 'atLeastOneRoom',

    // Service suggestions
    serviceSuggestionPsychology = 'serviceSuggestionPsychology',
    serviceSuggestionPhysiotherapy = 'serviceSuggestionPhysiotherapy',
    serviceSuggestionPilates = 'serviceSuggestionPilates',
    serviceSuggestionPsychiatry = 'serviceSuggestionPsychiatry',
    serviceSuggestionNutrition = 'serviceSuggestionNutrition',
    serviceSuggestionCoaching = 'serviceSuggestionCoaching',
    serviceSuggestionMassageTherapy = 'serviceSuggestionMassageTherapy',

    // Room suggestions
    roomSuggestionRoom1 = 'roomSuggestionRoom1',
    roomSuggestionRoom2 = 'roomSuggestionRoom2',
    roomSuggestionOnline = 'roomSuggestionOnline',
    roomSuggestionStudio = 'roomSuggestionStudio',
    roomSuggestionWellnessRoom = 'roomSuggestionWellnessRoom',

    professionalNamePlaceholder = 'professionalNamePlaceholder',
    professionalNameOptional = 'professionalNameOptional',
    professionalEmailOptional = 'professionalEmailOptional',
    professionalsOptionalDescription = 'professionalsOptionalDescription',
    inviteMoreLater = 'inviteMoreLater',
    emailRequired = 'emailRequired',
    passwordRequired = 'passwordRequired',
    emailOrNameRequired = 'emailOrNameRequired',
    theseWillBeYourAdminCredentials = 'theseWillBeYourAdminCredentials',
    closeOnboardingWizard = 'closeOnboardingWizard',
    goToPreviousStep = 'goToPreviousStep',

    // Settings categories
    settingsCategoryGeneral = 'settingsCategoryGeneral',
    settingsCategoryBilling = 'settingsCategoryBilling',
    settingsCategoryFeatures = 'settingsCategoryFeatures',
    settingsCategoryProfessionals = 'settingsCategoryProfessionals',
    settingsCategoryClients = 'settingsCategoryClients',
    settingsCategoryCommunication = 'settingsCategoryCommunication',
    settingsCategoryIntegrations = 'settingsCategoryIntegrations',
    noFeaturesEnabled = 'noFeaturesEnabled',
    directLoginLinks = 'directLoginLinks',
    appInformation = 'appInformation',
    home = 'home',
    automaticPayments = 'automaticPayments',
    clientsAccess = 'clientsAccess',
    paymentAccount = 'paymentAccount',
    apiAccountId = 'apiAccountId',
    apiKey = 'apiKey',
    easypayApiConfigNote = 'easypayApiConfigNote',
    easypayPaymentAccountConfigNote = 'easypayPaymentAccountConfigNote',
    easypayTestMode = 'easypayTestMode',
    easypayTestModeDescription = 'easypayTestModeDescription',
    createYourPaymentsAccount = 'createYourPaymentsAccount',
    viewEasypayCommissions = 'viewEasypayCommissions',
    easypayCommissionsTitle = 'easypayCommissionsTitle',
    easypayCommissionPercentage = 'easypayCommissionPercentage',
    easypayCommissionFixed = 'easypayCommissionFixed',
    easypayOfficialPricingNote = 'easypayOfficialPricingNote',
    webhookSettingsDescription = 'webhookSettingsDescription',
    automaticPaymentsSettingsDescription = 'automaticPaymentsSettingsDescription',
    reportsSettingsDescription = 'reportsSettingsDescription',
    paymentProfilesSettingsDescription = 'paymentProfilesSettingsDescription',
    updatePackVersionsTitle = 'updatePackVersionsTitle',
    updatePackVersionsDescription = 'updatePackVersionsDescription',
    updatePackAllVersionsDisclaimer = 'updatePackAllVersionsDisclaimer',
    updateLatestVersionOnly = 'updateLatestVersionOnly',
    updateLatestVersionOnlyDescription = 'updateLatestVersionOnlyDescription',
    updateAllVersions = 'updateAllVersions',
    updateAllVersionsDescription = 'updateAllVersionsDescription',
    packsAndSubscriptionsSettingsDescription = 'packsAndSubscriptionsSettingsDescription',
    invoicesSettingsDescription = 'invoicesSettingsDescription',
    invoicesNotSupportedInThisCountry = 'invoicesNotSupportedInThisCountry',
    extrasSettingsDescription = 'extrasSettingsDescription',
    clientsAccessSettingsDescription = 'clientsAccessSettingsDescription',
    ocupancy = 'ocupancy',
    occupancyRate = 'occupancyRate',
    occupancyRateProfessionalsDescription = 'occupancyRateProfessionalsDescription',
    occupancyRateRoomsDescription = 'occupancyRateRoomsDescription',
    appointmentTime = 'appointmentTime',
    availableTime = 'availableTime',
    numberOfAppointments = 'numberOfAppointments',
    noDataAvailable = 'noDataAvailable',
    invoiceNotCreatedYet = 'invoiceNotCreatedYet',
    generalInformation = 'generalInformation',
    pricingDetails = 'pricingDetails',
    basePrice = 'basePrice',
    extra = 'extra',
    noPaymentsFound = 'noPaymentsFound',
    invoiceNumber = 'invoiceNumber',
    seeDetails = 'seeDetails',
    hideDetails = 'hideDetails',
    googleSignIn = 'googleSignIn',
    connected = 'connected',
    notConnected = 'notConnected',
    saved = 'saved',
    userAssociatedWithProfessional = 'userAssociatedWithProfessional',
    professionalAssociatedWithUser = 'professionalAssociatedWithUser',
    createUserFromProfessional = 'createUserFromProfessional',
    selectProfessional = 'selectProfessional',
    seeProfessionalProfile = 'seeProfessionalProfile',
    noneOption = 'noneOption',
    navigateToUserProfile = 'navigateToUserProfile',
    createUserForProfessional = 'createUserForProfessional',
    pay = 'pay',
    updateMyInvoiceInformation = 'updateMyInvoiceInformation',
    saving = 'saving',
    configureAccessAndProfessionals = 'configureAccessAndProfessionals',
    adminCredentials = 'adminCredentials',
    inviteProfessionals = 'inviteProfessionals',
    inviteProfessionalsTooltip = 'inviteProfessionalsTooltip',
    trial = 'trial',
    addonNotAvailableForMonthlyBilling = 'addonNotAvailableForMonthlyBilling',
    signature = 'signature',
    fullWidth = 'fullWidth',
    fieldWidth = 'fieldWidth',
    fieldWidthMedium = 'fieldWidthMedium',
    fieldWidthSmall = 'fieldWidthSmall',
    alignRight = 'alignRight',
    blankSpace = 'blankSpace',
    testPrint = 'testPrint',
    preview = 'preview',
    iAcceptThe = 'iAcceptThe',
    iAcknowledgeThe = 'iAcknowledgeThe',
    iWantToReceiveFeatureUpdates = 'iWantToReceiveFeatureUpdates',
    youMustAcceptTermsAndPrivacy = 'youMustAcceptTermsAndPrivacy',
    appointmentsMustBelongToSameClient = 'appointmentsMustBelongToSameClient',
    invoiceClientMismatch = 'invoiceClientMismatch',

    // Invoice settings validation
    webAppointmintManagedInvoicesSetupSuccess = 'webAppointmintManagedInvoicesSetupSuccess',
    webInvoiceSettingsAppointmintConfigRequired = 'webInvoiceSettingsAppointmintConfigRequired',
    webInvoiceSettingsFiscalCredsRequired = 'webInvoiceSettingsFiscalCredsRequired',
    webInvoiceSettingsAddressRequired = 'webInvoiceSettingsAddressRequired',
    webInvoiceSettingsPostalCodeRequired = 'webInvoiceSettingsPostalCodeRequired',
    webInvoiceSettingsCityRequired = 'webInvoiceSettingsCityRequired',
    webInvoiceSettingsTaxExemptionInvalid = 'webInvoiceSettingsTaxExemptionInvalid',
    webInvoiceSettingsInvoicexpressConfigRequired = 'webInvoiceSettingsInvoicexpressConfigRequired',
    webInvoiceSettingsInvoicexpressCredsRequired = 'webInvoiceSettingsInvoicexpressCredsRequired',
    webInvoiceSettingsCegidvendusConfigRequired = 'webInvoiceSettingsCegidvendusConfigRequired',
    webInvoiceSettingsCegidvendusCredsRequired = 'webInvoiceSettingsCegidvendusCredsRequired',
    webInvoiceSettingsSaftEmailsRequired = 'webInvoiceSettingsSaftEmailsRequired',
    webInvoiceSettingsSaftDayInvalid = 'webInvoiceSettingsSaftDayInvalid',
    ignoreMarketingConsent = 'ignoreMarketingConsent',
    clientsWithTags = 'clientsWithTags',
    until = 'until',

    // Client Intelligent Categorization
    intelligentCategorization = 'intelligentCategorization',
    intelligentCategorizationDescription = 'intelligentCategorizationDescription',
    enabled = 'enabled',
    thresholdDays = 'thresholdDays',
    thresholdDaysHelp = 'thresholdDaysHelp',
    daysSinceLastAppointment = 'daysSinceLastAppointment',
    selectColor = 'selectColor',
    selectIcon = 'selectIcon',
    configureIntelligentClientTags = 'configureIntelligentClientTags',
    tagName = 'tagName',
    ruleEnabled = 'ruleEnabled',
    activeTagHelp = 'activeTagHelp',
    atRiskTagHelp = 'atRiskTagHelp',
    inactiveTagHelp = 'inactiveTagHelp',
    debtorTagHelp = 'debtorTagHelp',
    lastRunDate = 'lastRunDate',
    debtOutstandingFor = 'debtOutstandingFor',
    clientTagActive = 'clientTagActive',
    clientTagAtRisk = 'clientTagAtRisk',
    clientTagInactive90 = 'clientTagInactive90',
    clientTagInactive180 = 'clientTagInactive180',
    clientTagInactive365 = 'clientTagInactive365',
    clientTagDebtor = 'clientTagDebtor',

    // Cash Register Settings
    cashRegister = 'cashRegister',
    cashRegisterEnabled = 'cashRegisterEnabled',
    cashRegisterEnabledHelp = 'cashRegisterEnabledHelp',
    cashRegisterPaymentTypes = 'cashRegisterPaymentTypes',
    cashRegisterAllPaymentTypes = 'cashRegisterAllPaymentTypes',
    cashRegisterApprovers = 'cashRegisterApprovers',
    cashRegisterApproversHelp = 'cashRegisterApproversHelp',
    cashRegisterSharedNames = 'cashRegisterSharedNames',
    cashRegisterSharedNamesHelp = 'cashRegisterSharedNamesHelp',
    cashRegisterHistory = 'cashRegisterHistory',
    cashRegisterNoEntries = 'cashRegisterNoEntries',
    cashRegisterHandledBy = 'cashRegisterHandledBy',
    cashRegisterPending = 'cashRegisterPending',
    cashRegisterBalanceLabel = 'cashRegisterBalanceLabel',
    cashRegisterBalanceHelp = 'cashRegisterBalanceHelp',
    cashRegisterToProcess = 'cashRegisterToProcess',
    cashRegisterShowAllHistory = 'cashRegisterShowAllHistory',
    cashRegisterNoPendingEntries = 'cashRegisterNoPendingEntries',
    cashRegisterHandleAll = 'cashRegisterHandleAll',
    cashRegisterHandleType = 'cashRegisterHandleType',
    cashRegisterConfirmHandle = 'cashRegisterConfirmHandle',
    cashRegisterTotal = 'cashRegisterTotal',
    cashRegisterTransactions = 'cashRegisterTransactions',
    cashRegisterReserveAmount = 'cashRegisterReserveAmount',
    cashRegisterReserveLabel = 'cashRegisterReserveLabel',
    cashRegisterReserveDescription = 'cashRegisterReserveDescription',
    cashRegisterSelectRegister = 'cashRegisterSelectRegister',
    cashRegisterOwnRegister = 'cashRegisterOwnRegister',
    cashRegisterCurrentRegister = 'cashRegisterCurrentRegister',
    cashRegisterChangeRegister = 'cashRegisterChangeRegister',
    cashRegisterProcessRegister = 'cashRegisterProcessRegister',
    cashRegisterWithdraw = 'cashRegisterWithdraw',
    cashRegisterWithdrawAmount = 'cashRegisterWithdrawAmount',
    cashRegisterWithdrawExceedsTotal = 'cashRegisterWithdrawExceedsTotal',
    cashRegisterConfirmWithdraw = 'cashRegisterConfirmWithdraw',
    cashRegisterProcessDescription = 'cashRegisterProcessDescription',
    cashRegisterWithdrawDescription = 'cashRegisterWithdrawDescription',
    cashRegisterPageInfo = 'cashRegisterPageInfo',
    cashRegisterDefaultRegister = 'cashRegisterDefaultRegister',
    cashRegisterDefaultRegisterHelp = 'cashRegisterDefaultRegisterHelp',
    cashRegisterQuickSale = 'cashRegisterQuickSale',
    cashRegisterAssociatedSource = 'cashRegisterAssociatedSource',
    cashRegisterNoUnpaidSources = 'cashRegisterNoUnpaidSources',
    cashRegisterQuickFlowInfo = 'cashRegisterQuickFlowInfo',
    cashRegisterAddAppointment = 'cashRegisterAddAppointment',
    cashRegisterAddPack = 'cashRegisterAddPack',
    cashRegisterAddSubscription = 'cashRegisterAddSubscription',
    cashRegisterNoUnpaidAppointments = 'cashRegisterNoUnpaidAppointments',
    cashRegisterNoPacks = 'cashRegisterNoPacks',
    cashRegisterNoSubscriptions = 'cashRegisterNoSubscriptions',
    cashRegisterGroupPending = 'cashRegisterGroupPending',
    cashRegisterGroupAvailable = 'cashRegisterGroupAvailable',
    cashRegisterOpen = 'cashRegisterOpen',
    cashRegisterTransfer = 'cashRegisterTransfer',
    cashRegisterConfirmTransfer = 'cashRegisterConfirmTransfer',
    cashRegisterTransferAmount = 'cashRegisterTransferAmount',
    cashRegisterTransferDestination = 'cashRegisterTransferDestination',
    cashRegisterTransferDescription = 'cashRegisterTransferDescription',
    cashRegisterTransferTo = 'cashRegisterTransferTo',
    cashRegisterTransferFrom = 'cashRegisterTransferFrom',
    cashRegisterTransferSameRegister = 'cashRegisterTransferSameRegister',
    cashRegisterTransferExceedsTotal = 'cashRegisterTransferExceedsTotal',
    cashRegisterDeposit = 'cashRegisterDeposit',
    cashRegisterDepositAmount = 'cashRegisterDepositAmount',
    cashRegisterWithdrawCanGoNegative = 'cashRegisterWithdrawCanGoNegative',
    cashRegisterHandled = 'cashRegisterHandled',
    cashRegisterDays = 'cashRegisterDays',
    cashRegisterPeriod = 'cashRegisterPeriod',
    cashRegisterMovement = 'cashRegisterMovement',
    cashRegisterManage = 'cashRegisterManage',
    cashRegisterBackToSale = 'cashRegisterBackToSale',
    cashRegisterPaymentType = 'cashRegisterPaymentType',
    cashRegisterCountedCash = 'cashRegisterCountedCash',
    cashRegisterExpectedCash = 'cashRegisterExpectedCash',
    cashRegisterDiscrepancy = 'cashRegisterDiscrepancy',
    cashRegisterOver = 'cashRegisterOver',
    cashRegisterShort = 'cashRegisterShort',
    cashRegisterCountedCashHelp = 'cashRegisterCountedCashHelp',
    cashRegisterCashPaymentType = 'cashRegisterCashPaymentType',
    cashRegisterCashPaymentTypeHelp = 'cashRegisterCashPaymentTypeHelp',
    cashRegisterCashPaymentTypeAuto = 'cashRegisterCashPaymentTypeAuto',
    standaloneInvoicePaymentsWarning = 'standaloneInvoicePaymentsWarning',

    showReportInline = 'showReportInline',
    printZoom = 'printZoom',
    source = 'source',
    documentType = 'documentType',

    twoFactorAuthentication = 'twoFactorAuthentication',
    twoFactorAuthenticationHelp = 'twoFactorAuthenticationHelp',
    authenticator = 'authenticator',
    invalidPortuguesePhoneNumber = 'invalidPortuguesePhoneNumber',
    enterVerificationCode = 'enterVerificationCode',
    verificationCodeSentTo = 'verificationCodeSentTo',
    enterAuthenticatorCode = 'enterAuthenticatorCode',
    verify = 'verify',
    invalidOrExpiredCode = 'invalidOrExpiredCode',
    authenticatorSetup = 'authenticatorSetup',
    authenticatorSetupDescription = 'authenticatorSetupDescription',
    authenticatorConfigured = 'authenticatorConfigured',
    authenticatorNotConfigured = 'authenticatorNotConfigured',
    setupAuthenticator = 'setupAuthenticator',
    disableAuthenticator = 'disableAuthenticator',
    scanQrCode = 'scanQrCode',
    orEnterManually = 'orEnterManually',
    confirmSetup = 'confirmSetup',
    authenticatorSetupSuccess = 'authenticatorSetupSuccess',
    authenticatorDisabled = 'authenticatorDisabled',
    recommended = 'recommended',
    forLandingPageIntegration = 'forLandingPageIntegration',

    // Clients Portals & Mintu
    clientsPortalsAndMintu = 'clientsPortalsAndMintu',
    clientsPortal = 'clientsPortal',
    clientsPortalDescription = 'clientsPortalDescription',
    onlineScheduling = 'onlineScheduling',
    configuration = 'configuration',
    notifications = 'notifications',
    mintuAiWhatsApp = 'mintuAiWhatsApp',
    mintuDescription = 'mintuDescription',
    mintuNotEnabledWarning = 'mintuNotEnabledWarning',
    mintuCustomInstructions = 'mintuCustomInstructions',
    mintuCustomInstructionsHelp = 'mintuCustomInstructionsHelp',
    mintuConfigurationTabNote = 'mintuConfigurationTabNote',
    mintuWhatsAppSection = 'mintuWhatsAppSection',
    mintuWhatsAppSectionDescription = 'mintuWhatsAppSectionDescription',
    mintuWhatsAppCopyEmbedCode = 'mintuWhatsAppCopyEmbedCode',
    mintuWhatsAppOpenInWhatsApp = 'mintuWhatsAppOpenInWhatsApp',
    mintuWhatsAppQrCodeAlt = 'mintuWhatsAppQrCodeAlt',
    mintuWhatsAppScanQrCode = 'mintuWhatsAppScanQrCode',
    experimentMintuNow = 'experimentMintuNow',
    experimentMintuNowDescription = 'experimentMintuNowDescription',
    documentsSettingsDescription = 'documentsSettingsDescription',
    document = 'document',
    documents = 'documents',
    generic = 'generic',
    files = 'files',

    // Mintu pause
    mintuActive = 'mintuActive',
    mintuPaused = 'mintuPaused',
    mintuPauseFor = 'mintuPauseFor',
    mintuResume = 'mintuResume',
    mintuPausedUntil = 'mintuPausedUntil',
    mintuPause1Hour = 'mintuPause1Hour',
    mintuPause2Hours = 'mintuPause2Hours',
    mintuPause4Hours = 'mintuPause4Hours',
    mintuPause8Hours = 'mintuPause8Hours',
    mintuPause24Hours = 'mintuPause24Hours',
    onlyMyOwn = 'onlyMyOwn',
    permissionDoNotAllowSkipAvailabilityDescription = 'permissionDoNotAllowSkipAvailabilityDescription',
    permissionDoNotAllowToConfirmAppointmentsDescription = 'permissionDoNotAllowToConfirmAppointmentsDescription',
    permissionDoNotShowPricesDescription = 'permissionDoNotShowPricesDescription',
    permissionDoNotCreateOrEditAppointmentsDescription = 'permissionDoNotCreateOrEditAppointmentsDescription',
    doNotAllowSkipAvailability = 'doNotAllowSkipAvailability',
    doNotAllowToConfirmAppointments = 'doNotAllowToConfirmAppointments',
    doNotShowPrices = 'doNotShowPrices',
    doNotCreateOrEditAppointments = 'doNotCreateOrEditAppointments',
    noPermissionToCreateOrEditAppointmentsContactAdmin = 'noPermissionToCreateOrEditAppointmentsContactAdmin',
    allowInvoicesEmission = 'allowInvoicesEmission',
    allowInvoicesCancellation = 'allowInvoicesCancellation',
    noWhatsAppQuotaAvailableAddMoreIn = 'noWhatsAppQuotaAvailableAddMoreIn',
    waitingList = 'waitingList',
    addToWaitingList = 'addToWaitingList',
    noEntries = 'noEntries',
    addedBy = 'addedBy',
    addedAt = 'addedAt',
    clientsWaitingForProfessional = 'clientsWaitingForProfessional',
    clientsWaitingForServiceOrProfessional = 'clientsWaitingForServiceOrProfessional',
    waitingListNewSlotSmsTemplate = 'waitingListNewSlotSmsTemplate',
    ignore = 'ignore',
    waitingLists = 'waitingLists',
    waitingListSettings = 'waitingListSettings',
    waitingListSettingsDescription = 'waitingListSettingsDescription',
    removeFromWaitingListWhenAppointmentCreated = 'removeFromWaitingListWhenAppointmentCreated',
    removeFromWaitingListWhenAppointmentCreatedHelp = 'removeFromWaitingListWhenAppointmentCreatedHelp',
    priority = 'priority',
    limitDate = 'limitDate',
    priorityNormal = 'priorityNormal',
    priorityHigh = 'priorityHigh',
    priorityUrgent = 'priorityUrgent',
    limitDateHelpText = 'limitDateHelpText',
    waitingListsCancellationPromptInfo = 'waitingListsCancellationPromptInfo',
    waitingTime = 'waitingTime',
    waitingDaysShort = 'waitingDaysShort',
    insights = 'insights',
    list = 'list',
    averageWaitTime = 'averageWaitTime',
    longestWaitTime = 'longestWaitTime',
    entriesResolved = 'entriesResolved',
    removalReasonManual = 'removalReasonManual',
    removalReasonAppointmentCreated = 'removalReasonAppointmentCreated',
    durationDays = 'durationDays',
    removalReason = 'removalReason',
    removedAt = 'removedAt',
    entriesByService = 'entriesByService',
    averageWaitTimeByService = 'averageWaitTimeByService',
    entriesByProfessional = 'entriesByProfessional',
    oldestEntry = 'oldestEntry',
    highPriorityEntries = 'highPriorityEntries',
    expiringEntries = 'expiringEntries',
    errorLoadingData = 'errorLoadingData',
    appointmentsPaied = 'appointmentsPaied',
    appointmentsNotPaied = 'appointmentsNotPaied',
    addPartnerCode = 'addPartnerCode',
    partnerCode = 'partnerCode',
    partnerId = 'partnerId',
    partnerCodeTooltip = 'partnerCodeTooltip',
    overpaidAmount = 'overpaidAmount',
    showAllPaymentAttempts = 'showAllPaymentAttempts',
    sendPaymentLink = 'sendPaymentLink',
    noUnpaidAppointments = 'noUnpaidAppointments',
    surveys = 'surveys',
    survey = 'survey',
    surveyResponse = 'surveyResponse',
    sendSurvey = 'sendSurvey',
    clientEmailRequiredForSurvey = 'clientEmailRequiredForSurvey',
    clientPhoneRequiredForSurvey = 'clientPhoneRequiredForSurvey',
    clientContactRequiredForSurvey = 'clientContactRequiredForSurvey',
    automaticSurvey = 'automaticSurvey',
    automaticSurveyHelp = 'automaticSurveyHelp',
    surveyImmutableNotice = 'surveyImmutableNotice',
    createForm = 'createForm',
    surveyBuilder = 'surveyBuilder',
    surveyEmailTemplate = 'surveyEmailTemplate',
    surveyField = 'surveyField',
    surveyNoFields = 'surveyNoFields',
    surveyFieldTypeMultilineText = 'surveyFieldTypeMultilineText',
    surveyFieldTypeSingleLineText = 'surveyFieldTypeSingleLineText',
    surveyFieldTypeIntNumber = 'surveyFieldTypeIntNumber',
    surveyFieldTypeMultiOptions = 'surveyFieldTypeMultiOptions',
    surveyFieldTypeScale = 'surveyFieldTypeScale',
    surveyFieldTypeDate = 'surveyFieldTypeDate',
    surveyLinkExpired = 'surveyLinkExpired',
    surveySubmitted = 'surveySubmitted',
    surveySubmittedBody = 'surveySubmittedBody',
    surveyAlreadyCompleted = 'surveyAlreadyCompleted',
    noData = 'noData',
    noSurveyResponse = 'noSurveyResponse',
    noSurveys = 'noSurveys',
    fieldLabel = 'fieldLabel',
    fieldType = 'fieldType',
    fieldOptions = 'fieldOptions',
    scaleRange = 'scaleRange',
    surveySharePerspective = 'surveySharePerspective',
    surveyFormInstructions = 'surveyFormInstructions',
    surveyPrivacyOptions = 'surveyPrivacyOptions',
    surveySubmitAnonymously = 'surveySubmitAnonymously',
    surveyAnonymousHelp = 'surveyAnonymousHelp',
    surveyStatusOpen = 'surveyStatusOpen',
    surveyStatusCompleted = 'surveyStatusCompleted',
    surveyReviewAndSubmit = 'surveyReviewAndSubmit',
    surveyAlreadyCompletedFooter = 'surveyAlreadyCompletedFooter',
    surveyMissingRequiredFields = 'surveyMissingRequiredFields',
    surveyWelcomeWithName = 'surveyWelcomeWithName',
    surveyWelcomeGeneric = 'surveyWelcomeGeneric',
    surveyFields = 'surveyFields',
    surveyHonestFeedbackTitle = 'surveyHonestFeedbackTitle',
    surveyHonestFeedbackBody = 'surveyHonestFeedbackBody',
    surveyHintScale = 'surveyHintScale',
    surveyHintMultiOptions = 'surveyHintMultiOptions',
    surveyHintText = 'surveyHintText',
    surveyHintDate = 'surveyHintDate',
    surveyHintNumber = 'surveyHintNumber',
    surveySelectToInspect = 'surveySelectToInspect',
    editSurvey = 'editSurvey',
    surveyEmailDefaultSubject = 'surveyEmailDefaultSubject',
    surveyEmailDefaultBody = 'surveyEmailDefaultBody',
    surveyEmailSenderName = 'surveyEmailSenderName',
    surveyEmailSenderAddress = 'surveyEmailSenderAddress',
    surveyQuestions = 'surveyQuestions',
    surveyDescription = 'surveyDescription',
    surveyDescriptionHelp = 'surveyDescriptionHelp',
    surveyEmailBodyHelp = 'surveyEmailBodyHelp',
    surveyChannelSection = 'surveyChannelSection',
    surveyDescriptionPlaceholder = 'surveyDescriptionPlaceholder',
    surveyConfigurationSection = 'surveyConfigurationSection',
    surveyEmailSection = 'surveyEmailSection',
    surveyPreview = 'surveyPreview',
    surveySaveToPreviewDisclaimer = 'surveySaveToPreviewDisclaimer',
    surveyPreviewBanner = 'surveyPreviewBanner',
    surveyAutomaticTriggersSection = 'surveyAutomaticTriggersSection',
    surveyIsDefaultAutomaticSurvey = 'surveyIsDefaultAutomaticSurvey',
    surveyIsDefaultAutomaticSurveyHelp = 'surveyIsDefaultAutomaticSurveyHelp',
    surveyAutomaticServiceTypes = 'surveyAutomaticServiceTypes',
    surveyAutomaticServiceTypesHelp = 'surveyAutomaticServiceTypesHelp',
    surveyAutoCreateClient = 'surveyAutoCreateClient',
    surveyAutoCreateClientHelp = 'surveyAutoCreateClientHelp',
    surveysFeatureDescription = 'surveysFeatureDescription',
    surveySentCount = 'surveySentCount',
    surveyResponseCount = 'surveyResponseCount',
    surveySentAt = 'surveySentAt',
    surveySubmittedAt = 'surveySubmittedAt',
    surveySubmittedAnonymously = 'surveySubmittedAnonymously',
    surveyAnonymousAnswersHidden = 'surveyAnonymousAnswersHidden',
    surveyAwaitingResponse = 'surveyAwaitingResponse',
    surveyWhatsAppDefaultMessage = 'surveyWhatsAppDefaultMessage',
    surveyChannelEmail = 'surveyChannelEmail',
    surveyChannelWhatsApp = 'surveyChannelWhatsApp',

    // Pre-payment service settings
    prePayment = 'prePayment',
    prePaymentEnabled = 'prePaymentEnabled',
    prePaymentEnabledHelp = 'prePaymentEnabledHelp',
    applicableServices = 'applicableServices',
    applicableServicesHelp = 'applicableServicesHelp',
    applicableServicesPlaceholder = 'applicableServicesPlaceholder',
    autoDeleteIfNotPaid = 'autoDeleteIfNotPaid',
    autoDeleteIfNotPaidHelp = 'autoDeleteIfNotPaidHelp',
    autoDeleteDaysAfterCreation = 'autoDeleteDaysAfterCreation',
    autoDeleteDaysAfterCreationHelp = 'autoDeleteDaysAfterCreationHelp',
    autoDeleteDaysBeforeAppointment = 'autoDeleteDaysBeforeAppointment',
    autoDeleteDaysBeforeAppointmentHelp = 'autoDeleteDaysBeforeAppointmentHelp',
    autoDeleteIfNotPaidOnDayOfMonth = 'autoDeleteIfNotPaidOnDayOfMonth',
    autoDeleteIfNotPaidOnDayOfMonthHelp = 'autoDeleteIfNotPaidOnDayOfMonthHelp',
    autoDeleteGroups = 'autoDeleteGroups',
    autoDeleteGroupsHelp = 'autoDeleteGroupsHelp',
    addGroup = 'addGroup',
    group = 'group',
    disableAutoDeleteForGroup = 'disableAutoDeleteForGroup',
    paymentMissingAutoCancelOn = 'paymentMissingAutoCancelOn',
    paymentReminder = 'paymentReminder',
    paymentReminderHelp = 'paymentReminderHelp',
    paymentConfirmedNotification = 'paymentConfirmedNotification',
    paymentConfirmedNotificationHelp = 'paymentConfirmedNotificationHelp',
    paymentCancelledNotification = 'paymentCancelledNotification',
    paymentCancelledNotificationHelp = 'paymentCancelledNotificationHelp',

    // Birthday message settings
    birthdayMessage = 'birthdayMessage',
    birthdayMessageEnabled = 'birthdayMessageEnabled',
    birthdayMessageEnabledHelp = 'birthdayMessageEnabledHelp',
    birthdayMessageIncludeClientTags = 'birthdayMessageIncludeClientTags',
    birthdayMessageIncludeClientTagsHelp = 'birthdayMessageIncludeClientTagsHelp',
    birthdayMessageIncludeClientTagsPlaceholder = 'birthdayMessageIncludeClientTagsPlaceholder',
    birthdayMessageExcludeClientTags = 'birthdayMessageExcludeClientTags',
    birthdayMessageExcludeClientTagsHelp = 'birthdayMessageExcludeClientTagsHelp',
    birthdayMessageSendAtTime = 'birthdayMessageSendAtTime',
    birthdayMessageChannels = 'birthdayMessageChannels',
    birthdayMessageWhatsAppCustomFarewell = 'birthdayMessageWhatsAppCustomFarewell',
    birthdayMessageWhatsAppCustomFarewellHelp = 'birthdayMessageWhatsAppCustomFarewellHelp',

    // Google Calendar sync
    googleCalendarSettingsTitle = 'googleCalendarSettingsTitle',
    googleSettingsTitle = 'googleSettingsTitle',
    googleCalendarDescription = 'googleCalendarDescription',
    googleCalendarConnected = 'googleCalendarConnected',
    googleCalendarNotConnected = 'googleCalendarNotConnected',
    googleCalendarConnect = 'googleCalendarConnect',
    googleCalendarDisconnect = 'googleCalendarDisconnect',
    googleCalendarDisconnectConfirmTitle = 'googleCalendarDisconnectConfirmTitle',
    googleCalendarDisconnectConfirmBody = 'googleCalendarDisconnectConfirmBody',
    googleCalendarConnectError = 'googleCalendarConnectError',
    googleCalendarDisconnectError = 'googleCalendarDisconnectError',
    googleCalendarConnectSuccess = 'googleCalendarConnectSuccess',
    googleCalendarProfessionalNote = 'googleCalendarProfessionalNote',
    appointmentNotHappened = 'appointmentNotHappened',

    // Cookie consent
    cookieConsentMessage = 'cookieConsentMessage',
    cookieConsentAccept = 'cookieConsentAccept',
    cookieConsentDecline = 'cookieConsentDecline',

    shareOptions = 'shareOptions',
    shareWithClient = 'shareWithClient',
    shareWithClientHelp = 'shareWithClientHelp',
    shareWithClientTooltip = 'shareWithClientTooltip',
    shareWithProfessionalsWithService = 'shareWithProfessionalsWithService',
    shareWithAllProfessionals = 'shareWithAllProfessionals',
    shareWithAllProfessionalsHelp = 'shareWithAllProfessionalsHelp',
    shareWithAdministratives = 'shareWithAdministratives',
    shareWithAdministrativesHelp = 'shareWithAdministrativesHelp',
    shareWithSpecificUsers = 'shareWithSpecificUsers',
    shareWithSpecificUsersHelp = 'shareWithSpecificUsersHelp',

    // Google Review
    googleReviews = 'googleReviews',
    googleReviewsSettingsTitle = 'googleReviewsSettingsTitle',
    googleReviewsDescription = 'googleReviewsDescription',
    googleReviewsTriggerHint = 'googleReviewsTriggerHint',
    googleReviewsViewAnalytics = 'googleReviewsViewAnalytics',
    googleReviewUrl = 'googleReviewUrl',
    googleReviewUrlHelp = 'googleReviewUrlHelp',
    googleReviewUrlNotConfiguredTooltip = 'googleReviewUrlNotConfiguredTooltip',
    googleReviewUrlRequired = 'googleReviewUrlRequired',
    googleReviewSmsQuotaExhaustedTooltip = 'googleReviewSmsQuotaExhaustedTooltip',
    googleReviewWhatsAppQuotaExhaustedTooltip = 'googleReviewWhatsAppQuotaExhaustedTooltip',
    googleReviewWhatsAppPhoneRequiredTooltip = 'googleReviewWhatsAppPhoneRequiredTooltip',
    googleReviewWhatsAppRequirementsMissingTooltip = 'googleReviewWhatsAppRequirementsMissingTooltip',
    requestGoogleReview = 'requestGoogleReview',
    requestGoogleReviewConfirmTitle = 'requestGoogleReviewConfirmTitle',
    requestGoogleReviewConfirmBody = 'requestGoogleReviewConfirmBody',
    requestGoogleReviewSuccess = 'requestGoogleReviewSuccess',
    googleReviewSelectBranchPlaceholder = 'googleReviewSelectBranchPlaceholder',
    googleReviewBranchUrlLabel = 'googleReviewBranchUrlLabel',
    googleReviewBranchUrlHelp = 'googleReviewBranchUrlHelp',
    googleReviewIconTooltipNotSent = 'googleReviewIconTooltipNotSent',
    googleReviewIconTooltipPending = 'googleReviewIconTooltipPending',
    googleReviewIconTooltipSubmittedPositive = 'googleReviewIconTooltipSubmittedPositive',
    googleReviewIconTooltipSubmittedNegative = 'googleReviewIconTooltipSubmittedNegative',
    googleReviewAnalyticsTotalSent = 'googleReviewAnalyticsTotalSent',
    googleReviewAnalyticsTotalOpened = 'googleReviewAnalyticsTotalOpened',
    googleReviewAnalyticsTotalSubmitted = 'googleReviewAnalyticsTotalSubmitted',
    googleReviewAnalyticsTotalClickedGoogle = 'googleReviewAnalyticsTotalClickedGoogle',
    googleReviewAnalyticsStarDistribution = 'googleReviewAnalyticsStarDistribution',
    googleReviewAnalyticsPositiveComments = 'googleReviewAnalyticsPositiveComments',
    googleReviewAnalyticsImprovementNotes = 'googleReviewAnalyticsImprovementNotes',
    googleReviewSmsTemplateLabel = 'googleReviewSmsTemplateLabel',
    googleReviewSmsTemplatePlaceholders = 'googleReviewSmsTemplatePlaceholders',
    googleReviewEmailBodyLabel = 'googleReviewEmailBodyLabel',
    googleReviewEmailBodyNote = 'googleReviewEmailBodyNote',
    googleReviewWhatsAppPreviewLabel = 'googleReviewWhatsAppPreviewLabel',
    googleReviewWhatsAppMetaNote = 'googleReviewWhatsAppMetaNote',
    googleReviewTestSection = 'googleReviewTestSection',
    googleReviewChannelEditableSubtitle = 'googleReviewChannelEditableSubtitle',
    googleReviewWhatsAppChannelSubtitle = 'googleReviewWhatsAppChannelSubtitle',
    googleReviewSmsDefaultTemplate = 'googleReviewSmsDefaultTemplate',
    googleReviewEmailDefaultTemplate = 'googleReviewEmailDefaultTemplate',

    clientProfileSettings = 'clientProfileSettings',
    importClients = 'importClients',
    exportCsv = 'exportCsv',
    importClientsAnalysing = 'importClientsAnalysing',
    importClientsUploadPrompt = 'importClientsUploadPrompt',
    importClientsUploadAccept = 'importClientsUploadAccept',
    importClientsUploadError = 'importClientsUploadError',
    importClientsDragHere = 'importClientsDragHere',
    importClientsUnmappedColumns = 'importClientsUnmappedColumns',
    importClientsMappingRequired = 'importClientsMappingRequired',
    importClientsSkipExistingOnly = 'importClientsSkipExistingOnly',
    importClientsSkippedExistingRowWarning = 'importClientsSkippedExistingRowWarning',
    importClientsWillCreate = 'importClientsWillCreate',
    importClientsWillUpdate = 'importClientsWillUpdate',
    importClientsWillSkip = 'importClientsWillSkip',
    importClientsWillSkipExisting = 'importClientsWillSkipExisting',
    importClientsSkippedRowWarning = 'importClientsSkippedRowWarning',
    importClientsStartImport = 'importClientsStartImport',
    importClientsStepUpload = 'importClientsStepUpload',
    importClientsStepMap = 'importClientsStepMap',
    importClientsStepPreview = 'importClientsStepPreview',
    importClientsStepImport = 'importClientsStepImport',
    importClientsErrors = 'importClientsErrors',
    importClientsCancelled = 'importClientsCancelled',
    importClientsDone = 'importClientsDone',
    importClientsAndNMore = 'importClientsAndNMore',

    clearDuplicates = 'clearDuplicates',
    clearDuplicatesStepOptions = 'clearDuplicatesStepOptions',
    clearDuplicatesStepFetch = 'clearDuplicatesStepFetch',
    clearDuplicatesStepAnalyse = 'clearDuplicatesStepAnalyse',
    clearDuplicatesStepExecution = 'clearDuplicatesStepExecution',
    clearDuplicatesByField = 'clearDuplicatesByField',
    clearDuplicatesDeletionRule = 'clearDuplicatesDeletionRule',
    clearDuplicatesRuleNoEntities = 'clearDuplicatesRuleNoEntities',
    clearDuplicatesRuleFewerEntities = 'clearDuplicatesRuleFewerEntities',
    clearDuplicatesGroupsFound = 'clearDuplicatesGroupsFound',
    clearDuplicatesWillDelete = 'clearDuplicatesWillDelete',
    clearDuplicatesWillKeep = 'clearDuplicatesWillKeep',
    clearDuplicatesFetching = 'clearDuplicatesFetching',
    clearDuplicatesNoResult = 'clearDuplicatesNoResult',
    clearDuplicatesAnalysing = 'clearDuplicatesAnalysing',
    clearDuplicatesDeleted = 'clearDuplicatesDeleted',
    clearDuplicatesDone = 'clearDuplicatesDone',
    clearDuplicatesSkipped = 'clearDuplicatesSkipped',
    clearDuplicatesStartExecution = 'clearDuplicatesStartExecution',

    importAppointments = 'importAppointments',
    importAppointmentsAnalysing = 'importAppointmentsAnalysing',
    importAppointmentsUploadPrompt = 'importAppointmentsUploadPrompt',
    importAppointmentsUploadAccept = 'importAppointmentsUploadAccept',
    importAppointmentsUploadError = 'importAppointmentsUploadError',
    importAppointmentsStepUpload = 'importAppointmentsStepUpload',
    importAppointmentsStepMap = 'importAppointmentsStepMap',
    importAppointmentsStepMapProfessionals = 'importAppointmentsStepMapProfessionals',
    importAppointmentsStepMapServices = 'importAppointmentsStepMapServices',
    importAppointmentsStepPreview = 'importAppointmentsStepPreview',
    importAppointmentsStepImport = 'importAppointmentsStepImport',
    importAppointmentsDragHere = 'importAppointmentsDragHere',
    importAppointmentsUnmappedColumns = 'importAppointmentsUnmappedColumns',
    importAppointmentsMappingRequired = 'importAppointmentsMappingRequired',
    importAppointmentsCreateMissingClients = 'importAppointmentsCreateMissingClients',
    importAppointmentsDefaultRoom = 'importAppointmentsDefaultRoom',
    importAppointmentsNoRoom = 'importAppointmentsNoRoom',
    importAppointmentsDefaultDuration = 'importAppointmentsDefaultDuration',
    importAppointmentsMapProfessionals = 'importAppointmentsMapProfessionals',
    importAppointmentsSkipAppointments = 'importAppointmentsSkipAppointments',
    importAppointmentsProfessionalMappingRequired = 'importAppointmentsProfessionalMappingRequired',
    importAppointmentsMapServices = 'importAppointmentsMapServices',
    importAppointmentsUseAsIs = 'importAppointmentsUseAsIs',
    importAppointmentsStartImport = 'importAppointmentsStartImport',
    importAppointmentsPreviewOutcome = 'importAppointmentsPreviewOutcome',
    importAppointmentsPreviewCreateCount = 'importAppointmentsPreviewCreateCount',
    importAppointmentsPreviewSkipCount = 'importAppointmentsPreviewSkipCount',
    importAppointmentsPreviewErrorCount = 'importAppointmentsPreviewErrorCount',
    importAppointmentsPreviewNewClientCount = 'importAppointmentsPreviewNewClientCount',
    importAppointmentsStatusCreate = 'importAppointmentsStatusCreate',
    importAppointmentsStatusSkip = 'importAppointmentsStatusSkip',
    importAppointmentsStatusError = 'importAppointmentsStatusError',
    importAppointmentsStatusNewClient = 'importAppointmentsStatusNewClient',
    importAppointmentsErrorInvalidDate = 'importAppointmentsErrorInvalidDate',
    importAppointmentsErrorNoProfessional = 'importAppointmentsErrorNoProfessional',
    importAppointmentsErrorUnknownProfessional = 'importAppointmentsErrorUnknownProfessional',
    importAppointmentsErrorNoClient = 'importAppointmentsErrorNoClient',
    importAppointmentsErrorClientNotFound = 'importAppointmentsErrorClientNotFound',
    importAppointmentsImporting = 'importAppointmentsImporting',
    importAppointmentsDone = 'importAppointmentsDone',
    importAppointmentsCancelled = 'importAppointmentsCancelled',
    importAppointmentsCreated = 'importAppointmentsCreated',
    importAppointmentsErrors = 'importAppointmentsErrors',
    importAppointmentsAlreadyExists = 'importAppointmentsAlreadyExists',
    importAppointmentsCreatingClient = 'importAppointmentsCreatingClient',
    importAppointmentsFieldStatus = 'importAppointmentsFieldStatus',
    importAppointmentsAndNMore = 'importAppointmentsAndNMore',
    importAppointmentsProfessionalNotFound = 'importAppointmentsProfessionalNotFound',

    // Delete Appointments
    deleteAppointments = 'deleteAppointments',
    deleteAppointmentsSelectRangeHint = 'deleteAppointmentsSelectRangeHint',
    deleteAppointmentsFrom = 'deleteAppointmentsFrom',
    deleteAppointmentsTo = 'deleteAppointmentsTo',
    deleteAppointmentsNone = 'deleteAppointmentsNone',
    deleteAppointmentsConfirmCount = 'deleteAppointmentsConfirmCount',
    deleteAppointmentsDeleting = 'deleteAppointmentsDeleting',
    deleteAppointmentsDoneMsg = 'deleteAppointmentsDoneMsg',
    deleteAppointmentsDeleted = 'deleteAppointmentsDeleted',
    deleteAppointmentsErrors = 'deleteAppointmentsErrors',
    deleteAppointmentsDeleteOnly = 'deleteAppointmentsDeleteOnly',
    deleteAppointmentsDeleteOnlyPlaceholder = 'deleteAppointmentsDeleteOnlyPlaceholder',
    deleteAppointmentsDoNotDelete = 'deleteAppointmentsDoNotDelete',

    // Client Properties
    clientProperties = 'clientProperties',
    clientPropertiesHelpNote = 'clientPropertiesHelpNote',
    professionalCanView = 'professionalCanView',
    professionalCanEdit = 'professionalCanEdit',
    clientCanView = 'clientCanView',
    clientCanEdit = 'clientCanEdit',
    hide = 'hide',
    builtInFields = 'builtInFields',
    additionalProperties = 'additionalProperties',
    bookPersonalTime = 'bookPersonalTime',
    personalTime = 'personalTime',
    honorarios = 'honorarios',
    toPay = 'toPay',

    // Group Appointment
    participants = 'participants',
    addClient = 'addClient',
    attended = 'attended',
    noSubscriptionForType = 'noSubscriptionForType',
    confirmAllParticipants = 'confirmAllParticipants',

    packsAndSubscriptions = 'packsAndSubscriptions',

    // Prescriptions
    prescriptionNumCedula = 'prescriptionNumCedula',
    prescriptionOrdemProfissional = 'prescriptionOrdemProfissional',
    prescriptionOrdemMedicos = 'prescriptionOrdemMedicos',
    prescriptionOrdemDentistas = 'prescriptionOrdemDentistas',
    prescriptionOrdemOdontologistas = 'prescriptionOrdemOdontologistas',
    prescriptionEspecialidadeCodigo = 'prescriptionEspecialidadeCodigo',
    prescriptions = 'prescriptions',
    prescriptionsSettingsDescription = 'prescriptionsSettingsDescription',
    prescriptionSpmsLocalPrescricaoCodigo = 'prescriptionSpmsLocalPrescricaoCodigo',
    prescriptionSpmsSubsistemaEntidadeCodigo = 'prescriptionSpmsSubsistemaEntidadeCodigo',
    prescriptionSpmsSubsistemaEntidadeDominio = 'prescriptionSpmsSubsistemaEntidadeDominio',
    prescriptionSpmsSubsistemaEntidadePais = 'prescriptionSpmsSubsistemaEntidadePais',
    prescriptionSpmsLocalPrescricaoCodigoHelp = 'prescriptionSpmsLocalPrescricaoCodigoHelp',
    prescriptionSpmsSubsistemaEntidadeCodigoHelp = 'prescriptionSpmsSubsistemaEntidadeCodigoHelp',
    prescriptionSpmsSubsistemaEntidadeDominioHelp = 'prescriptionSpmsSubsistemaEntidadeDominioHelp',
    prescriptionSpmsSubsistemaEntidadePaisHelp = 'prescriptionSpmsSubsistemaEntidadePaisHelp',
    prescriptionNew = 'prescriptionNew',
    prescriptionNumber = 'prescriptionNumber',
    prescriptionPin = 'prescriptionPin',
    prescriptionState = 'prescriptionState',
    prescriptionStatePending = 'prescriptionStatePending',
    prescriptionStateRegistered = 'prescriptionStateRegistered',
    prescriptionStateError = 'prescriptionStateError',
    prescriptionMedicationLine = 'prescriptionMedicationLine',
    prescriptionAddLine = 'prescriptionAddLine',
    prescriptionRemoveLine = 'prescriptionRemoveLine',
    prescriptionPrint = 'prescriptionPrint',
    prescriptionCnPem = 'prescriptionCnPem',
    prescriptionSubstanciaActiva = 'prescriptionSubstanciaActiva',
    prescriptionFormaFarmaceutica = 'prescriptionFormaFarmaceutica',
    prescriptionEmbalagem = 'prescriptionEmbalagem',
    prescriptionDosagem = 'prescriptionDosagem',
    prescriptionQuantidade = 'prescriptionQuantidade',
    prescriptionInstrucoes = 'prescriptionInstrucoes',
    prescriptionTipoReceita = 'prescriptionTipoReceita',
    prescriptionRenovavel = 'prescriptionRenovavel',
    prescriptionNumeroSNS = 'prescriptionNumeroSNS',
    prescription = 'prescription',
    prescriptionStateCancelled = 'prescriptionStateCancelled',
    prescriptionNumeroReceita = 'prescriptionNumeroReceita',
    prescriptionPinReceita = 'prescriptionPinReceita',
    prescriptionPinDireitoOpcao = 'prescriptionPinDireitoOpcao',
    prescriptionLines = 'prescriptionLines',
    prescriptionSpmsResultCode = 'prescriptionSpmsResultCode',
    prescriptionSpmsResultMessage = 'prescriptionSpmsResultMessage',

    topDebtors = 'topDebtors',
    debtByMonth = 'debtByMonth',

    checkAvailability = 'checkAvailability',
    selectServiceOrProfessional = 'selectServiceOrProfessional',
    noSlotsAvailable = 'noSlotsAvailable',
    confirmSlot = 'confirmSlot',
    conflictingAppointmentsWarning = 'conflictingAppointmentsWarning',
    bookAnyway = 'bookAnyway',

    reportTemplateCatalogTitle = 'reportTemplateCatalogTitle',
    reportTemplateCatalogDescription = 'reportTemplateCatalogDescription',
    chooseFromCatalog = 'chooseFromCatalog',
    startFromScratch = 'startFromScratch',
    useTemplate = 'useTemplate',
    reportTemplateCategoryGeneral = 'reportTemplateCategoryGeneral',
    reportTemplateCategoryPsychology = 'reportTemplateCategoryPsychology',
    reportTemplateCategoryPsychiatry = 'reportTemplateCategoryPsychiatry',
    reportTemplateCategoryPhysiotherapy = 'reportTemplateCategoryPhysiotherapy',
    reportTemplateCategoryNutrition = 'reportTemplateCategoryNutrition',
    reportTemplateCategoryDentistry = 'reportTemplateCategoryDentistry',
    age = 'age',
    birthday = 'birthday',
    clientFileNumber = 'clientFileNumber',
    weekDay = 'weekDay',
    firstAppointmentDate = 'firstAppointmentDate',
    firstAppointmentTime = 'firstAppointmentTime',
    paymentLink = 'paymentLink',
    bookingLink = 'bookingLink',
    unsubscribeLink = 'unsubscribeLink',
    reviewLink = 'reviewLink',
    surveyLink = 'surveyLink',
    consentLink = 'consentLink',
    customFarewell = 'customFarewell',
    addDynamicField = 'addDynamicField',
    followUp = 'followUp',
    misc = 'misc',
    customFields = 'customFields',

    aiScriber = 'aiScriber',
    aiScriberSelectTemplate = 'aiScriberSelectTemplate',
    aiScriberSelectTemplatePlaceholder = 'aiScriberSelectTemplatePlaceholder',
    aiScriberRequestingMicrophone = 'aiScriberRequestingMicrophone',
    aiScriberRecording = 'aiScriberRecording',
    aiScriberStopRecording = 'aiScriberStopRecording',
    aiScriberStopping = 'aiScriberStopping',
    aiScriberTranscriptReady = 'aiScriberTranscriptReady',
    aiScriberTranscriptLabel = 'aiScriberTranscriptLabel',
    aiScriberMicrophonePermissionDenied = 'aiScriberMicrophonePermissionDenied',
    aiScriberStartError = 'aiScriberStartError',
    aiScriberClose = 'aiScriberClose',
    aiScriberStart = 'aiScriberStart',
    aiScriberProcessing = 'aiScriberProcessing',
    aiScriberDraftReady = 'aiScriberDraftReady',
    aiScriberDraftReadyHint = 'aiScriberDraftReadyHint',
    aiScriberAiLabel = 'aiScriberAiLabel',
    aiScriberAccept = 'aiScriberAccept',
    aiScriberAdditionalNotes = 'aiScriberAdditionalNotes',
    aiScriberWarnings = 'aiScriberWarnings',
    aiScriberFillReport = 'aiScriberFillReport',
}
